const game = {
    services: {},
    settings: {
        quality: 'auto',
        disableChat: false
    },
    isPlayScreen: false
};

function escapeHtml(str) {
    return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
game.showGrowl = (message, data) => {
    $.bootstrapGrowl(escapeHtml(message), data);
};

try {
    let newSettings = window.localStorage.getItem('settings');
    try {
        if (newSettings) {
            game.settings = JSON.parse(newSettings);
        }
    } catch (e) {
        console.error('Failed to parse settings.');
    }
} catch (e) {}

if (window.location.pathname === '/play/') {
    game.isPlayScreen = true;
}

const fontFamily = ['Recursive', 'sans-serif'];

const snapshotRate = (1000/6);
(function() {
    let ENABLE_DEBUG = false;
    let running = false;
    let WIDTH = window.innerWidth;
    let HEIGHT = window.innerHeight;
    let TILE_SIZE = 64;
    let MAP_SIZE = 6000/TILE_SIZE;
    let AFK_TIME_TILL_KICK = 3;
    let AFK_TIME_TILL_KICK_WARNING = 2;
    let DISABLE_AFK = false;
    let idleTime = 0;
    let serverTimeDiff = 0;
    let lastWeather = null;
    let currentWeather = null;
    let currentSeason = {
        type: 'spring'
    };
    let nextSeason = currentSeason;
    let nightVal = 0;
    let targetNightVal = 0;
    let weatherVal = 0;
    let seasonVal = 0;
    let spectating = false;
    let scoreboardData = null;
    let worldData = {};

    if (!PIXI.utils.isWebGLSupported()) {
        game.showGrowl('WebGL is not enabled/supported. This may cause issues!', {
            type: 'danger',
            align: 'center',
            allow_dismiss: false,
            width: 500,
            delay: 5000
        });
        game.settings.quality = 'low';
    }

    PIXI.settings.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = false;
    let app = new PIXI.Application(WIDTH, HEIGHT, {
        backgroundColor: 0x000000,
        roundPixels: true,
        antialias: false,
        FAIL_IF_MAJOR_PERFORMANCE_CAVEAT: false
    });
    game.app = app;
    app.stop();
    PIXI.SCALE_MODES.DEFAULT = PIXI.SCALE_MODES.NEAREST;
    app.view.id = 'gameCanvas';
    document.body.appendChild(app.view);

    let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    let isSmallMobile = isMobile && (WIDTH <= 900 || HEIGHT <= 900);
    let isSmallestMobile = isMobile && (WIDTH <= 800 || HEIGHT <= 800);
    game.isMobile = isMobile;

    let inOverlayMenu = false;

    let fixedTimeStep;
    let gameSpeed = 1;
    let currentMenu = null;
    let mx = 0;
    let my = 0;
    let gmx = 0;
    let gmy = 0;
    let mouseDown = false;
    let entities = [];
    let entityDictionary = {};
    let effects = [];
    let player = null;
    let tileData = null;
    let tiles = null;
    let socket = null;
    let socket2 = null;
    let yearEndData = null;
    let teamInfo = null;
    let tileContainers = [];
    let tilesSurfaceSpritesheet = null;
    let isSwitchingPlayer = false;
    let isSelectingFollow = false;
    let glowHighlightFilter = new PIXI.filters.GlowFilter({
        distance: 10,
        outerStrength: 1,
        innerStrength: 0.25,
        color: 0xFFFFFF,
        quality: 0.2
    });

    let camera = {
        x: 0,
        y: -HEIGHT + 120,
        z: 0,
        zoom: 1
    };
    game.camera = camera;
    game.resetZoom = function() {
        if (camera.z <= -1) {
            camera.zoom = 0.6;
        } else if (isSmallestMobile) {
            camera.zoom = 0.75;
        } else if (isSmallMobile) {
            camera.zoom = 0.8;
        } else if(camera.z >= 1 && !isMobile) {
            camera.zoom = 1.3;
        } else {
            camera.zoom = 1;
        }
    };
    game.resetZoom();

    window.document.addEventListener('contextmenu', function (evt) {
        if (game.isPlayScreen) {
            evt.preventDefault();
        }
    });

    let debugText = null;
    let resources = null;
    let sounds = null;
    let asset_list = {
        white: 'white.png',
        alpha: 'alpha.png',
        tiles: 'tiles2.png',
        edge_tiles: 'edge_tiles.png',
        tiles_surface: 'tiles_surface.png',
        arrow_pointer: 'arrow_pointer.png',
        spider: 'spider.png',
        spider2: 'spider2.png',
        tutorial_avatar: 'tutorial_avatar.png',
        gui: 'gui.png',
        anthill: 'anthill.png',
        anthill_small: 'anthill_small.png',
        anthill_below: 'anthill_below.png',
        resources: 'resources.png',
        brood: 'brood.png',
        dirt: 'dirt.png',
        aphid: 'aphid.png',
        clover: 'clover2.png',
        snowflake: 'snowflake.png',
        tags: 'tags.png',
        rock1: 'rock1.png',
        rock2: 'rock2.png',
        rock3: 'rock3.png',
        rock4: 'rock4.png',
        tree_stump: 'tree_stump.png',
        crushed_can: 'crushed_can.png',
        bottle: 'bottle.png',
        leaves: 'leaves.png',
        leaf_particles: 'leaf_particles.png',
        sticks: 'sticks.png',
        pheromone: 'pheromone.png',
        outside: 'outside.png',
        grub: 'grub.png',
        bg0: 'bg0.png',
        bg1: 'bg1.png',
        bg2: 'bg2.png',
        bg3: 'bg3.png',
        underground_bg: 'underground_bg.png',
        antenna: 'antenna.png',
        ant_worker: 'worker.png',
        ant_soldier: 'soldier.png',
        ant_queen: 'queen.png',
        ant_queen_wings: 'queen_wings.png',
        bug: 'bug.png',
        beetle: 'beetle.png',
        centipede: 'centipede.png',
        raindrop: 'raindrop.png',
        head_32x32_1: 'head_32x32_1.png',
        acid: 'acid.png',
    };

    var soundsLoaded = false;
    function loadSounds() {
        if (soundsLoaded) {
            return;
        }

        soundsLoaded = true;
        sounds = {
            collect: new Howl({
                urls: ["assets/collect.wav"],
                loop: false,
                volume: 0.05
            }),
            rank_up: new Howl({
                urls: ["assets/rank_up.wav"],
                loop: false,
                volume: 0.2
            }),
            beep: new Howl({
                urls: ['assets/beep.wav'],
                loop: false,
                volume: 0.1
            }),
            acid: new Howl({
                urls: ['assets/acid.ogg'],
                loop: false,
                volume: 0.25
            }),
            xp_collect: new Howl({
                urls: ['assets/xp_collect.mp3'],
                loop: false,
                volume: 0.1
            }),
            round_end: new Howl({
                urls: ['assets/round_end.wav'],
                loop: false,
                volume: 0.2
            }),
            aboveground: new Howl({
                urls: ['assets/ambient_aboveground.ogg'],
                loop: true,
                volume: 0.1
            }),
            aboveground_winter: new Howl({
                urls: ['assets/ambient_aboveground_winter.ogg'],
                loop: true,
                volume: 0.2
            }),
           aboveground_summer: new Howl({
                urls: ['assets/ambient_aboveground_summer.ogg'],
                loop: true,
                volume: 0.2
            }),
            aboveground_summer_night: new Howl({
                urls: ['assets/ambient_aboveground_summer_night.ogg'],
                loop: true,
                volume: 0.1
            }),
            aboveground_fall: new Howl({
                urls: ['assets/ambient_aboveground_fall.ogg'],
                loop: true,
                volume: 0.2
            }),
            aboveground_fall_night: new Howl({
                urls: ['assets/ambient_aboveground_fall_night.ogg'],
                loop: true,
                volume: 0.2
            }),
            rain: new Howl({
                urls: ['assets/rain.ogg'],
                loop: true,
                volume: 0.02
            }),
            aboveground_night: new Howl({
                urls: ['assets/ambient_aboveground_night.ogg'],
                loop: true,
                volume: 0.004
            }),
            underground: new Howl({
                urls: ['assets/ambient_underground.ogg'],
                loop: true,
                volume: 0.25
            }),
            walk: new Howl({
                urls: ['assets/walk_sound.ogg'],
                loop: true,
                volume: 0.25
            })
        };

        for (var i = 0; i < 5; i++) {
            sounds["thunder" + (i + 1)] = new Howl({
                urls: ["assets/thunder" + (i + 1) + ".ogg"],
                loop: false,
                volume: 0.06
            });
        }

        for (var i = 0; i < 4; i++) {
            sounds["wood_hit" + (i + 1)] = new Howl({
                urls: ["assets/wood_hit" + (i + 1) + ".mp3"],
                loop: false,
                volume: 0.1
            });
        }
        game.sounds = sounds;
    }
    game.loadSounds = loadSounds;

    game.updateQuality = function() {
        for (let i=0; i<entities.length; i++) {
            let entity = entities[i];
            entity.qualityChanged();
        }
        game.updateSettings();
    };

    game.updateSettings = function() {
        try {
            let settingsString = JSON.stringify(game.settings);
            window.localStorage.setItem('settings', settingsString);
        } catch(e) {
            console.error('Failed to update settings.');
        }
    };

    function loadAssets() {
        for (let key in asset_list) {
            PIXI.Loader.shared.add(key, 'assets/' + asset_list[key]);
        }

        if (game.isPlayScreen) {
            loadSounds();
        } else {
            sounds = {};
        }

        PIXI.Loader.shared.load();
    }

    let radialMenuContainer = null;
    let background = null;
    let backgroundFade = null;
    let spawnText = null;
    let announcementText = null;
    let guiSpritesheet = null;
    let tagsSpritesheet = null;
    let tutorialAvatarSpritesheet = null;
    let xpFeedText = null;
    let xpFeedList = [];
    let arrowSpritePointer = null;
    let queenHungryContainer = null;
    let tutorialContainer = null;
    let screenCoverSprite = null;
    let tipsText = null;
    let currentSandboxTool = null;
    let hasSandboxAccess = false;
    let latency = 0;
    let radialItems = [];

    let sandboxTimeSpedUp = false;
    function generateRadialMenu(newRadialItems) {
        currentSandboxTool = null;
        isSwitchingPlayer = false;

        if (radialMenuContainer) {
            app.cstage.removeChild(radialMenuContainer);
        }

        if (newRadialItems) {
            radialItems = newRadialItems;
        } else {
            if (game.isSandbox && spectating) {
                radialItems = [
                    {
                        command: 'Create'
                    },
                    {
                        command: 'Remove'
                    },
                    {
                        command: 'Terrain'
                    },
                    {
                        command: 'Weather'
                    },
                    {
                        command: sandboxTimeSpedUp ? 'Time x1' : 'Time x5'
                    },
                    {
                        command: 'Switch'
                    },
                    {
                        command: 'View Up/Down'
                    }
                ];
            } else {
                radialItems = [
                    {
                        command: '+5 Follow'
                    },
                    {
                        command: '+1 Follow'
                    },
                    {
                        command: 'Dismiss'
                    },
                    {
                        command: 'Switch'
                    },
                    {
                        command: 'Select Follow'
                    },
                    {
                        command: 'Commands'
                    }
                ];

                if (hasSandboxAccess) {
                    radialItems.push({
                        command: 'Sandbox'
                    });
                }
            }
        }

        radialMenuContainer = new PIXI.Container();
        let dist = 155;
        let circle = new PIXI.Graphics();
        circle.alpha = 0.5;
        circle.lineStyle(dist * 0.9, 0x000000);
        circle.drawCircle(0, 0, dist);
        circle.endFill();
        radialMenuContainer.addChild(circle);

        for (let i = 0; i < radialItems.length; i++) {
            let itemData = radialItems[i];
            let item = new PIXI.Text(itemData.command);
            itemData.text = item;
            let angle = i * ((Math.PI * 2) / radialItems.length) - (Math.PI / 2);
            item.anchor.x = 0.5;
            item.anchor.y = 0.5;
            item.style.fontSize = 22;
            item.style.fill = 0xFFFFFF;
            item.x = Math.cos(angle) * dist;
            item.y = Math.sin(angle) * dist;
            radialMenuContainer.addChild(item);
            itemData.x = item.x;
            itemData.y = item.y;

            if (!game.isSandbox) {
                let item2 = new PIXI.Text('Numpad ' + (i + 1));
                item2.anchor.x = 0.5;
                item2.anchor.y = 0.5;
                item2.style.fontSize = 14;
                item2.style.fill = 0xCCCCCC;
                item2.x = Math.cos(angle) * dist;
                item2.y = Math.sin(angle) * dist + 25;
                radialMenuContainer.addChild(item2);
            }

            let gfx = new PIXI.Graphics();
            angle += Math.PI/radialItems.length;
            gfx.lineStyle(2, '0xFFFFFF');
            gfx.moveTo(Math.cos(angle) * (dist * 0.5), Math.sin(angle) * (dist * 0.5));
            gfx.lineTo(Math.cos(angle) * (dist * 1.5), Math.sin(angle) * (dist * 1.5));
            radialMenuContainer.addChild(gfx);
        }
        radialMenuContainer.getZIndex = function () {
            return -8000
        };
        app.cstage.addChild(radialMenuContainer);
    }

    function onWindowResize() {
        if (isMobile) {
            WIDTH = window.innerWidth;
            HEIGHT = window.innerHeight;
            app.renderer.resize(WIDTH, HEIGHT);
        } else {
            let resolution = window.devicePixelRatio;
            let w = window.innerWidth;
            let h = window.innerHeight;
            app.renderer.view.style.width = w + 'px';
            app.renderer.view.style.height = h + 'px';
            WIDTH = Math.round(w * resolution);
            HEIGHT = Math.round(h * resolution);
            app.renderer.resize(WIDTH, HEIGHT);
        }

        if (!game.isPlayScreen) {
            camera.x = 0;
            camera.y = 0;
            MAP_SIZE = Math.round(WIDTH/TILE_SIZE)+5;
        }

        if (screenCoverSprite) {
            screenCoverSprite.width = WIDTH;
            screenCoverSprite.height = HEIGHT;
            screenCoverSprite.textObj.x = WIDTH / 2;
            announcementText.x = WIDTH / 2;
            spawnText.x = WIDTH / 2;
            tipsText.x = WIDTH / 2;
            queenHungryContainer.x = WIDTH / 2;
        }
    }
    window.addEventListener('resize', onWindowResize);

    PIXI.Loader.shared.onComplete.once(function (loader, res) {
        resources = res;
        console.info('Asset loading completed.');

        app.cstage = new PIXI.Container();
        app.stage.addChild(app.cstage);

        background = new PIXI.TilingSprite(resources['bg0'].texture);
        background.getZIndex = function () {
            return 100000;
        };
        background.clampMargin = -0.5;
        background.width = 4000;
        background.height = 4000;
        background.scale.x = 2;
        background.scale.y = 2;
        background.anchor.x = 0;
        background.anchor.y = 0;
        background.position.x = 0;
        background.position.y = 0;
        app.cstage.addChild(background);

        backgroundFade = new PIXI.TilingSprite(resources['bg1'].texture);
        backgroundFade.getZIndex = function () {
            return 10000;
        };
        background.clampMargin = -0.5;
        backgroundFade.width = 4000;
        backgroundFade.height = 4000;
        backgroundFade.scale.x = 2;
        backgroundFade.scale.y = 2;
        backgroundFade.anchor.x = 0;
        backgroundFade.anchor.y = 0;
        backgroundFade.position.x = 0;
        backgroundFade.position.y = 0;
        app.cstage.addChild(backgroundFade);

        guiSpritesheet = loadSpritesheet(resources['gui'].texture, 128, 128);
        tagsSpritesheet = loadSpritesheet(resources['tags'].texture, 64, 16);

        app.cstage.updateLayersOrder = function () {
            app.cstage.children.sort(function (a, b) {
                return b.getZIndex() - a.getZIndex()
            });
        };

        debugText = new PIXI.Text();
        debugText.visible = ENABLE_DEBUG;
        debugText.style.fill = 0xFFFFFF;
        debugText.anchor.x = 0;
        debugText.x = 10;
        debugText.y = 60;
        debugText.getZIndex = function () {
            return -10000
        };
        app.stage.addChild(debugText);

        spawnText = new PIXI.Text();
        spawnText.anchor.x = 0.5;
        spawnText.style.fill = 0xFFFFFF;
        spawnText.text = 'Waiting to be born...\nTap to Spectate';
        spawnText.x = WIDTH / 2;
        spawnText.style.align = 'center';
        spawnText.y = 100;
        spawnText.visible = false;
        spawnText.getZIndex = function () {
            return -10000
        };
        app.stage.addChild(spawnText);

        queenHungryContainer = new PIXI.Container();

        var queenHungryText = new PIXI.Text();
        queenHungryText.anchor.x = 0.5;
        queenHungryText.style.fill = 0xFFFFFF;
        queenHungryText.text = 'Queen is Hungry';
        queenHungryContainer.addChild(queenHungryText);

        var queenHungrySprite = new PIXI.Sprite(guiSpritesheet[0][0]);
        queenHungrySprite.x = -118;
        queenHungrySprite.y = -8;
        queenHungrySprite.scale.set(0.4);
        queenHungrySprite.anchor.x = 0.5;
        queenHungryContainer.addChild(queenHungrySprite);

        queenHungryContainer.x = WIDTH / 2;
        queenHungryContainer.y = 25;
        queenHungryContainer.visible = false;
        queenHungryContainer.getZIndex = function () {
            return -10000
        };
        app.stage.addChild(queenHungryContainer);

        tipsText = new PIXI.Text();
        tipsText.anchor.x = 0.5;
        tipsText.style.fill = 0xFFFFFF;
        tipsText.text = 'These are tips.';
        tipsText.style.align = 'center';
        tipsText.style.fontSize = 20;
        tipsText.x = WIDTH / 2;
        tipsText.y = 50;
        tipsText.visible = false;
        tipsText.getZIndex = function () {
            return -10000
        };
        app.stage.addChild(tipsText);

        arrowSpritePointer = new PIXI.Sprite(resources['arrow_pointer'].texture);
        arrowSpritePointer.visible = false;
        arrowSpritePointer.anchor.set(0.5);
        arrowSpritePointer.getZIndex = function () {
            return -10000
        };
        app.cstage.addChild(arrowSpritePointer);

        announcementText = new PIXI.Text();
        announcementText.anchor.x = 0.5;
        announcementText.style.align = 'center';
        announcementText.style.fontSize = 64;
        announcementText.style.fill = 0xFFFFFF;
        announcementText.x = WIDTH / 2;
        announcementText.y = 300;
        announcementText.visible = false;
        announcementText.getZIndex = function () {
            return -10000
        };
        app.stage.addChild(announcementText);

        xpFeedText = new MultiStyleText('', {
            'default': {
                fontSize: 22,
                fill: 0xFFFFFF,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 800,
                fontFamily: fontFamily
            },
            'imp': {
                fontWeight: 'bold',
                fontSize: 22,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 200,
                fontFamily: fontFamily,
                fill: 0xDB982C
            }
        });
        xpFeedText.alpha = 0;
        xpFeedText.displayTime = 0;
        xpFeedText.position.x = 10;
        xpFeedText.position.y = 80;
        app.stage.addChild(xpFeedText);

        screenCoverSprite = new PIXI.Sprite(resources['white'].texture);
        screenCoverSprite.tint = 0x000000;
        screenCoverSprite.visible = false;
        screenCoverSprite.width = WIDTH;
        screenCoverSprite.height = HEIGHT;
        screenCoverSprite.getZIndex = function () {
            return 10000;
        };
        app.stage.addChild(screenCoverSprite);

        screenCoverSprite.textObj = new PIXI.Text('Colony Info');
        screenCoverSprite.textObj.anchor.x = 0.5;
        screenCoverSprite.textObj.style.align = 'center';
        screenCoverSprite.textObj.style.fontSize = 50;
        screenCoverSprite.textObj.style.fill = 0xFFFFFF;
        screenCoverSprite.textObj.x = WIDTH / 2;
        screenCoverSprite.textObj.y = 300;
        screenCoverSprite.textObj.visible = false;
        app.stage.addChild(screenCoverSprite.textObj);

        tutorialAvatarSpritesheet = loadSpritesheet(resources['tutorial_avatar'].texture, 256, 256);
        tutorialContainer = new PIXI.Container();
        tutorialContainer.square = new PIXI.Sprite(resources['white'].texture);
        tutorialContainer.square.alpha = 0.5;
        tutorialContainer.square.tint = 0x000000;
        tutorialContainer.square.width = 1;
        tutorialContainer.square.height = 1;
        tutorialContainer.addChild(tutorialContainer.square);

        tutorialContainer.avatar = new PIXI.Sprite(tutorialAvatarSpritesheet[0][0]);
        var fontSize = 22;
        var tutorialSize = 200;
        if (isMobile) {
            tutorialSize = 128;
            fontSize = 14;
        }
        tutorialContainer.avatar.width = tutorialSize;
        tutorialContainer.avatar.height = tutorialSize;
        tutorialContainer.addChild(tutorialContainer.avatar);

        tutorialContainer.text = new MultiStyleText('', {
            'default': {
                fontSize: fontSize,
                fill: 0xFFFFFF,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 200
            },
            'imp': {
                fontWeight: 'bold',
                fontSize: fontSize,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 200,
                fill: 0xDB982C
            }
        });
        tutorialContainer.addChild(tutorialContainer.text);
        tutorialContainer.visible = false;
        app.stage.addChild(tutorialContainer);

        $('#loading').hide();
        app.start();

        if (game.queryData && game.queryData.token && game.queryData.address) {
            init();
        } else if (game.queryData && game.queryData.invite) {
            ga('send', {
                hitType: 'event',
                eventCategory: 'Lobby',
                eventAction: 'joinInvite'
            });

            setTimeout(function() {
                game.play(null);
            }, 100);
        }

        onWindowResize();
    });

    function onUpdateWorldData() {
        switch(worldData.specialEvent) {
            case 'christmas':
                PIXI.Loader.shared.add('wreath', 'assets/wreath.png');
                PIXI.Loader.shared.add('cantycane', 'assets/cantycane.png');
                break;
        }

        PIXI.Loader.shared.load((loader, newResources) => {
            resources = newResources;
            console.info('Additional assets loading completed.');
        });
    }

    function init() {
        var address = game.queryData.address;
        if (address === '127.0.0.1' || address === 'localhost') {
            address = window.location.hostname;
        }

        for (var i=0; i<entities.length; i++) {
            var entity = entities[i];
            entity.remove();
        }

        if (game.isMapEditor) {
            DISABLE_AFK = true;
            socket = {
                connected: true,
                on: function() {}
            };
        } else if (game.isSingleplayer) {
            DISABLE_AFK = true;
            socket = {
                connected: true,
                on: function(name, fn) {
                    game.fakeSockets.clientSocket.socketEvents[name] = fn;
                },
                emit: function(name, data) {
                    if (game.fakeSockets.worker) {
                        game.fakeSockets.worker.sendMessage(name, data);
                    } else {
                        game.fakeSockets.serverSocket.socketEvents[name](data);
                    }
                },
                socketEvents: {}
            };
            game.fakeSockets.clientSocket = socket;
        } else {
            socket = io('//' + address + ':' + game.queryData.port, {
                query: {
                    userToken: game.queryData.token,
                    gameSocketType: 'main'
                },
                closeOnBeforeunload: false,
                reconnection: false,
                transports: ['websocket'],
                upgrade: false
            });
        }

        game.mainSocket = socket;

        onSocketConnected();
        running = true;

        let snapPort = (parseInt(game.queryData.port ? game.queryData.port : '443'));
        socket.on('growl', function (message) {
            game.showGrowl(message, {type: 'danger'});
            if (game.lobbyChat && game.lobbyChat.component) {
                game.lobbyChat.component.addChatMessage({
                    message: message
                });
            }
        });

        socket.on('connect_error', function (err) {
            console.error(err);
            if (err) {
                game.showGrowl(err.message ? err.message : err, {type: 'danger'});
            } else {
                game.showGrowl('Failed to connect to server.', {type: 'danger'});
            }
        });

        socket.on('error', function (err) {
            console.error(err);
            if (err) {
                game.showGrowl(err.message ? err.message : err, {type: 'danger'});
            } else {
                game.showGrowl('Failed to connect to server.', {type: 'danger'});
            }
        });

        socket.on('socketTokenReceive', function (token) {
            socket2 = io('//' + address + ":" + snapPort, {
                query: {
                    token: token,
                    gameSocketType: 'snapshot'
                },
                closeOnBeforeunload: false,
                reconnection: false,
                transports: ['websocket'],
                upgrade: false
            });

            socket2.on('connect', function () {
                console.info('Websockets connected.');
                onSnapSocketConnected();
            });

            socket2.on('disconnect', function () {
                socket.disconnect();
            });
        });

        socket.on('changeTimeStep', function(timeStep) {
            fixedTimeStep = timeStep;
            if (fixedTimeStep <= 1000/100) {
                gameSpeed = 5;
            } else {
                gameSpeed = 1;
            }
        });

        socket.on('disconnect', function () {
            console.info('Websockets disconnected.');

            var text = new PIXI.Text('Disconnected from Game');
            text.style.fill = 0xFFFFFF;
            text.style.fontSize = 30;
            text.anchor.x = 0.5;
            text.x = WIDTH / 2;
            text.y = 200;
            app.stage.addChild(text);

            if (!socket.forcedDisconnect) {
                try {
                    if (navigator.userAgent.indexOf("Firefox") > 0) {
                        window.location = '/';
                    } else {
                        setTimeout(function () {
                            window.location = '/';
                        }, 1500);
                    }
                } catch (e) {
                    window.location = '/';
                }
            }
        });
    }
    game.init = init;

    function getTileData(tx, ty) {
        if (tx >= 0 && ty >= 0 && tx < MAP_SIZE && ty < MAP_SIZE) {
            return tileData[ty][tx];
        } else {
            return [1, 0];
        }
    }

    var TileDirection = {
        SOUTH_WEST: 0,
        SOUTH: 1,
        SOUTH_EAST: 2,
        WEST: 3,
        EAST: 4,
        NORTH_WEST: 5,
        NORTH: 6,
        NORTH_EAST: 7
    };
    var neighborMap = [
        {
            x: -1,
            y: 1,
        },
        {
            x: 0,
            y: 1,
        },
        {
            x: 1,
            y: 1,
        },
        {
            x: -1,
            y: 0,
        },

        {
            x: 1,
            y: 0,
        },
        {
            x: -1,
            y: -1,
        },
        {
            x: 0,
            y: -1,
        },
        {
            x: 1,
            y: -1,
        }
    ];

    var tilesSpritesheet = null;
    var tileEdgesSpritesheet = null;
    function updateTile(x, y) {
        try {
            if (!(x >= 0 && y >= 0 && x < MAP_SIZE && y < MAP_SIZE)) {
                return;
            }

            var tileData = getTileData(x, y)[0];
            var tile = tiles[y][x];
            if (!tile.tileBase) {
                var tileBase = new PIXI.Sprite();
                tileBase.width = TILE_SIZE;
                tileBase.height = TILE_SIZE;
                tile.addChild(tileBase);
                tile.tileBase = tileBase;

                var tileCorner = new PIXI.Sprite();
                tileCorner.width = TILE_SIZE;
                tileCorner.height = TILE_SIZE;
                tile.addChild(tileCorner);
                tile.tileCorner = tileCorner;

                var tileEdge = new PIXI.Sprite();
                tileEdge.width = TILE_SIZE;
                tileEdge.height = TILE_SIZE;
                tile.addChild(tileEdge);
                tile.tileEdge = tileEdge;

                tile.textureType = parseInt(Math.random() * 4);
                tile.moistureType = parseInt(Math.random() * 3);
            }

            if (tileData === 2) {
                tile.tileBase.texture = tilesSpritesheet[tile.textureType][4];
            } else if (tileData === 1) {
                tile.tileBase.texture = tilesSpritesheet[tile.textureType][1];
            } else {
                tile.tileBase.texture = tilesSpritesheet[tile.textureType][0];
            }

            tile.edges = 0;
            tile.corners = 0;
            for (var i = 0; i < neighborMap.length; i++) {
                var neighbor = neighborMap[i];
                var neighborData = getTileData(x + neighbor.x, y + neighbor.y);

                if (neighborData[0]) {
                    if (i === TileDirection.WEST) {
                        tile.edges += 1;
                    } else if (i === TileDirection.NORTH) {
                        tile.edges += 2;
                    } else if (i === TileDirection.EAST) {
                        tile.edges += 4;
                    } else if (i === TileDirection.SOUTH) {
                        tile.edges += 8;
                    } else if (i === TileDirection.NORTH_WEST) {
                        tile.corners += 1;
                    } else if (i === TileDirection.NORTH_EAST) {
                        tile.corners += 2;
                    } else if (i === TileDirection.SOUTH_EAST) {
                        tile.corners += 4;
                    } else if (i === TileDirection.SOUTH_WEST) {
                        tile.corners += 8;
                    }
                }
            }

            tile.visible = isCloseToPlayer(tile);

            if (tileData) {
                tile.tileCorner.visible = false;
                tile.tileEdge.visible = false;
            } else {
                tile.tileCorner.visible = tile.corners !== 0;
                tile.tileEdge.visible = tile.edges !== 0;
                tile.tileCorner.texture = tileEdgesSpritesheet[0][0];
                tile.tileEdge.texture = tileEdgesSpritesheet[0][0];
                if (tile.corners != 0) {
                    if (tileEdgesSpritesheet[tile.corners - 1][1]) {
                        tile.tileCorner.texture = tileEdgesSpritesheet[tile.corners - 1][1];
                    }
                }
                if (tile.edges != 0) {
                    if (tileEdgesSpritesheet[tile.edges - 1][0]) {
                        tile.tileEdge.texture = tileEdgesSpritesheet[tile.edges - 1][0];
                    }
                }
            }

            if (!tileData) {
                var moistureDist = 0.24;
                var moisture = getTileData(x, y)[1];
                if (moisture === 0) {
                    tile.tileBase.texture = tilesSpritesheet[0][3];
                } else if (moisture === 1) {
                    tile.tileBase.texture = tilesSpritesheet[0][2];
                } else if (moisture >= 1 - moistureDist) {
                    tile.tileBase.texture = tilesSpritesheet[tile.moistureType + 1][2];
                } else if (moisture <= moistureDist) {
                    tile.tileBase.texture = tilesSpritesheet[tile.moistureType + 1][3];
                }
            }
        } catch (e) {}
    }

    function blendColors(c0, c1, p) {
        var f = c0, t = c1, R1 = f >> 16, G1 = f >> 8 & 0x00FF, B1 = f & 0x0000FF, R2 = t >> 16, G2 = t >> 8 & 0x00FF,
            B2 = t & 0x0000FF;
        return (0x1000000 + (Math.round((R2 - R1) * p) + R1) * 0x10000 + (Math.round((G2 - G1) * p) + G1) * 0x100 + (Math.round((B2 - B1) * p) + B1));
    }


    let updatedEntityCount = 0;
    function onSnapshot(data) {
        let dataView = new DataView(data);

        let bytesRead = 0;

        let time = dataView.getFloat64(bytesRead);
        serverTimeDiff = Date.now() - time;
        //let time = Date.now();
        //serverTimeDiff = 0;
        bytesRead += 8;

        updatedEntityCount = 0;
        while (bytesRead < dataView.byteLength) {
            let id = dataView.getUint32(bytesRead);
            let entity = entityDictionary[id];
            if (entity) {
                let state = {
                    time: time,
                    serverTimeDiff: serverTimeDiff,
                    x: dataView.getFloat32(bytesRead + 4),
                    y: dataView.getFloat32(bytesRead + 8),
                    z: dataView.getInt8(bytesRead + 12),
                    rotation: dataView.getFloat32(bytesRead + 13)
                };
                bytesRead += 17;
                entity.addState(state);
                updatedEntityCount++;
            } else {
                bytesRead += 17;
            }
        }

        return null;
    }
    game.onSnapshot = onSnapshot;

    function onSnapSocketConnected() {
        let oldDecoderAdd = socket2.io.decoder.add;
        socket2.io.decoder.add = function (obj) {
            try {
                oldDecoderAdd.call(socket2.io.decoder, obj);
            } catch (e) {}
        };

        socket2.io.decoder.reconstructor = {
            takeBinaryData: game.onSnapshot,
            finishedReconstruction: function () {
            }
        };
    }

    game.chat = function(message) {
        if (game.settings.disableChat) {
            return;
        }

        idleTime = 0;
        socket.emit('chat', {
            local: true,
            message: message
        });
    };

    let currentPlayerData = null;
    function onSocketConnected() {
        if (!DISABLE_AFK) {
            var idleTimerId = setInterval(function idleTimer() {
                if ((currentMenu && currentMenu !== 'lobby') || (player && player.canControl)) {
                    idleTime = idleTime + 1;
                    if (idleTime === AFK_TIME_TILL_KICK_WARNING) {
                        announcementText.text = 'You will be kicked for inactivity in one minute.';
                        announcementText.visible = true;
                    } else if (idleTime >= AFK_TIME_TILL_KICK) {
                        socket.forcedDisconnect = true;
                        socket.disconnect();
                        clearInterval(idleTimerId);
                        announcementText.text = 'You have been kicked for inactivity.';
                        announcementText.visible = true;
                    }
                }
            }, 60000);
        }

        game.doSpawn = function (event, type) {
            event.preventDefault();
            socket.emit('spawn', {
                type: type
            });
        };

        socket.on('chat', function (data) {
            if (game.settings.disableChat) {
                return;
            }

            if (data.id) {
                for (var i = 0; i < entities.length; i++) {
                    var entity = entities[i];
                    if (data.id === entity.serverId) {
                        if (entity.chat) {
                            entity.chat.text = data.message;
                            entity.chat.visible = true;
                            entity.chat.removeChat = Date.now() + 5000;
                        }
                        break;
                    }
                }
            } else {
                if (data.channel === 'team') {
                    if (game.teamChat && game.teamChat.component) {
                        game.teamChat.component.addChatMessage(data);
                    }
                } else {
                    if (game.lobbyChat && game.lobbyChat.component) {
                        game.lobbyChat.component.addChatMessage(data);
                    }
                }
            }
        });

        let lastXpSoundPlay = Date.now();
        socket.on('xpfeed', function(data) {
            if (data.xp && data.type) {
                xpFeedList.push(data);
                let maxFeedSize = 12;
                if (isMobile) {
                    maxFeedSize = 5;
                }
                if (xpFeedList.length > maxFeedSize) {
                    xpFeedList.shift();
                }

                let text = '';
                for (let i=0; i<xpFeedList.length; i++) {
                    let xpf = xpFeedList[i];
                    let string = toTitleCase(xpf.type.split('_').join(' '));
                    text += '<imp>+' + xpf.xp + ' XP</imp> ' + string + '\n';
                }
                xpFeedText.text = text;

                xpFeedText.alpha = 1;
                xpFeedText.displayTime = 500;

                if (Date.now()-lastXpSoundPlay >= 500) {
                    let soundInc = data.xp/1000;
                    if (soundInc < 0) {
                        soundInc = 0;
                    }
                    if (soundInc > 0.2) {
                        soundInc = 0.2;
                    }
                    sounds['xp_collect'].volume(0.2 + soundInc);
                    sounds['xp_collect'].play();
                    lastXpSoundPlay = Date.now();
                }
            }
        });


        socket.on('teamInfo', function(data) {
            teamInfo = data;
            game.queenMenuComponent.setTeamInfo(teamInfo);
        });

        socket.on('openQueenMenu', function(data) {
            game.queenMenuComponent.setCurrentQueen(data);
        })

        socket.on('tutorialData', function(data) {
            if (data) {
                tutorialContainer.tutorialData = data;
                tutorialContainer.text.text = data.text;
                sounds['beep'].volume(0.08);
                sounds['beep'].play();
            } else {
                tutorialContainer.tutorialData = null;
            }
        });

        socket.on('yearEnded', function (data) {
            yearEndData = data;
            screenCoverSprite.visible = true;
            screenCoverSprite.alpha = 0;
        });

        socket.on('newYear', function (data) {
            yearEndData = null;
        });

        socket.on('updateNight', function (data) {
            targetNightVal = data.night ? 1 : 0;
            if (data.force) {
                nightVal = targetNightVal;
            }
        });

        socket.on('updateWeather', function (data) {
            lastWeather = currentWeather;
            currentWeather = data;
        });

        socket.on('updateSeason', function (data) {
            if (data.forceUpdate) {
                currentSeason = data;
                nextSeason = null;
                seasonVal = 1;
                announcementText.text = '';
                announcementText.visible = false;

                for (let i=0; i<effects.length; i++) {
                    let effect = effects[i];
                    effect.remove();
                }
            } else {
                if (nextSeason) {
                    currentSeason = nextSeason;
                }
                nextSeason = data;
                seasonVal = 0;
            }
        });

        socket.on('lightning', function (data) {
            currentWeather.lightning = {
                start: Date.now() + data.start,
                lightEnd: data.lightEnd,
                end: Date.now() + data.end,
                sound: data.sound
            };
        });

        socket.on('roundEnd', function (data) {
            screenCoverSprite.visible = false;
            screenCoverSprite.textObj.visible = false;
            game.roundEndComponent.showRoundEnd(data);
        });

        socket.on('showMenu', function (data) {
            if (data && data.menu === 'lobby') {
                if (game.roundEndComponent) {
                    game.roundEndComponent.showModal(false);
                }
                showingScoreboard = false;
                roundStartTimer = data.startTimer;
                if (game.lobbyComponent) {
                    game.lobbyComponent.showModal(true);
                    game.lobbyComponent.updateData(data);
                }

                if (effects.length) {
                    for (let i=0; i<effects.length; i++) {
                        let effect = effects[i];
                        effect.remove();
                    }
                    effects = [];
                }
            } else {
                if (game.lobbyComponent && !showingScoreboard) {
                    game.lobbyComponent.showModal(false);
                }
            }

            currentMenu = data && data.menu ? data.menu : data;
        });

        socket.on('setAnnouncement', function (message) {
            if (message) {
                announcementText.text = message;
                announcementText.visible = true;
            } else {
                announcementText.text = '';
                announcementText.visible = false;
            }
        });

        socket.on('tileUpdate', function (data) {
            if (data.val !== null && data.val !== undefined) {
                tileData[data.y][data.x][0] = data.val;
            }
            if (data.m !== null && data.m !== undefined) {
                tileData[data.y][data.x][1] = data.m;
            }

            for (var x = -1; x <= 1; x++) {
                for (var y = -1; y <= 1; y++) {
                    updateTile(data.x + x, data.y + y);
                }
            }
        });

        socket.on('worldData', function(data) {
            worldData = data;
            onUpdateWorldData();
        });

        socket.on('tileData', function (data) {
            tileData = data;

            for (var i=0; i<tileContainers.length; i++) {
                var tileContainer = tileContainers[i];
                app.cstage.removeChild(tileContainer);
            }

            tileContainers = [];

            tilesSpritesheet = loadSpritesheet(resources['tiles'].texture, 64, 64, 1);
            tileEdgesSpritesheet = loadSpritesheet(resources['edge_tiles'].texture, 64, 64, 1);
            tilesSurfaceSpritesheet = loadSpritesheet(resources['tiles_surface'].texture, 128, 128, 1);

            for (var i=0; i<entities.length; i++) {
                var entity = entities[i];
                if (entity.clientsideOnly) {
                    entity.remove();
                }
            }

            for (var z=0; z<2; z++) {
                var tileContainer = new PIXI.Container();
                tileContainer.getZIndex = function() {
                    return 10000;
                };

                MAP_SIZE = data.length;
                background.width = MAP_SIZE * TILE_SIZE;
                background.height = MAP_SIZE * TILE_SIZE;
                tiles = [];
                for (var y = 0; y < MAP_SIZE; y++) {
                    tiles.push([]);
                    for (var x = 0; x < MAP_SIZE; x++) {
                        var tile = new PIXI.Container();
                        tile.visible = false;
                        tile.position.x = x * TILE_SIZE;
                        tile.position.y = y * TILE_SIZE;
                        tileContainer.addChild(tile);
                        tiles[y][x] = tile;

                        if (z === 0) {
                            if (!tile.tileBase) {
                                var tileBase = new PIXI.Sprite();
                                tileBase.width = TILE_SIZE;
                                tileBase.height = TILE_SIZE;
                                tile.addChild(tileBase);
                                tile.tileBase = tileBase;

                                tile.textureType = parseInt(Math.random() * 4);
                                tile.moistureType = parseInt(Math.random() * 4);

                                tile.tileBase.anchor.set(0.5, 0.5);
                                tile.rotation = Math.random() * Math.PI * 2;
                            }

                            let td = getTileData(x, y);
                            let tileType = td[0];
                            let moisture = td[1];
                            tile.visible = (tileType === 0 || tileType === 1) && (moisture === 0 || moisture === 1);
                            if (tile.visible) {
                                if (moisture === 0) {
                                    tile.tileBase.texture = tilesSurfaceSpritesheet[tile.moistureType][1];
                                } else if (moisture === 1) {
                                    tile.tileBase.texture = tilesSurfaceSpritesheet[tile.moistureType][0];
                                }
                            }
                        } else {
                            updateTile(x, y);
                        }
                    }
                }

                app.cstage.addChild(tileContainer);
                tileContainers[z] = tileContainer;
            }

            /*
            for (let i=0; i<40; i++) {
                let pos = {x: Math.random() * MAP_SIZE * TILE_SIZE, y: Math.random() * MAP_SIZE * TILE_SIZE};
                let size = 400 + Math.round(Math.random() * 200);
                let entity = createObject(-1, 'stick', pos.x, pos.y, 0, size, size*0.25, -1, {
                    stickType: Math.floor(Math.random()*4)
                });
                entity.rotation = Math.random()*Math.PI*2;
            }
            */
        });

        function createEntityFromData(data) {
            var entity = null;
            if (data.type === 'insect') {
                entity = createInsect(data.id, data.subtype, data.x, data.y, data.z, data.width, data.height, data.team, data.netData);
            } else if (data.type === 'object') {
                entity = createObject(data.id, data.subtype, data.x, data.y, data.z, data.width, data.height, data.team, data.netData);
            } else {
                console.error('Invalid entity type.');
            }

            if (entity) {
                entity.rotation = data.rotation;
                entityDictionary[entity.serverId] = entity;

                entity.addState({
                    time: Date.now() - serverTimeDiff,
                    serverTimeDiff: serverTimeDiff,
                    x: entity.x,
                    y: entity.y,
                    z: entity.z,
                    rotation: entity.rotation
                });

                entity.qualityChanged();
            }

            return entity;
        }

        socket.on('createEntity', function (data) {
            if (data && Array.isArray(data)) {
                for (let i=0; i<data.length; i++) {
                    let entityData = data[i];
                    if (!entityDictionary[entityData.id]) {
                        createEntityFromData(entityData);
                    } else if (!game.isSingleplayer) {
                        console.error('Tried to create entity that already exists:', entityData.id);
                    }
                }
            } else {
                createEntityFromData(data);
            }
        });

        socket.on('entityrpc', function (data) {
            if (entityDictionary[data.id]) {
                let entity = entityDictionary[data.id];
                if (entity[data.name]) {
                    entity[data.name](data.data);
                }
            } else {
                for (var i = 0; i < entities.length; i++) {
                    var entity = entities[i];
                    if (data.id === entity.serverId) {
                        if (entity[data.name]) {
                            entity[data.name](data.data);
                        } else {
                            console.error('Invalid RPC for entity:', data.name, entity.type);
                        }
                        break;
                    }
                }
            }
        });

        socket.on('removeEntity', function (id) {
            if (id && Array.isArray(id)) {
                for (let i=0; i<id.length; i++) {
                    let entityId = id[i];
                    if (entityDictionary[entityId]) {
                        entityDictionary[entityId].remove();
                        delete entityDictionary[entityId];
                    }
                }
            } else {
                if (entityDictionary[id]) {
                    entityDictionary[id].remove();
                    delete entityDictionary[id];
                } else {
                    for (let i = 0; i < entities.length; i++) {
                        let entity = entities[i];
                        if (id === entity.serverId) {
                            entity.remove();
                        }
                    }
                }
            }
        });

        socket.on('setPlayer', function (data) {
            game.isSandbox = data ? data.isSandbox : false;

            if (game.isSandbox) {
                hasSandboxAccess = true;
            }

            player = null;
            currentPlayerData = data;
        });

        socket.on('scoreboardData', function(data) {
            scoreboardData = data;
            updateScoreboard();
        });
    }

    function toggleCameraZ() {
        if (camera.z === 0) {
            camera.z = 1;

            game.resetZoom();
            let zoomRatio = (WIDTH*camera.zoom)/WIDTH;
            camera.x = ((camera.x + WIDTH/2) * zoomRatio) - WIDTH/2;
            camera.y = ((camera.y + HEIGHT/2) * zoomRatio) - HEIGHT/2;
        } else {
            camera.z = 0;
            let zoomRatio = WIDTH/(WIDTH*camera.zoom);
            game.resetZoom();
            camera.x = ((camera.x + WIDTH/2) * zoomRatio) - WIDTH/2;
            camera.y = ((camera.y + HEIGHT/2) * zoomRatio) - HEIGHT/2;
        }
    }

    var keyboardEventListenerObject = app.view;
    app.view.tabIndex = 0;

    var type_chat = false;
    var current_type_chat = "";
    var keys = {};
    var moveTimer = 0;
    keyboardEventListenerObject.addEventListener('keydown', function (event) {
        if (inOverlayMenu) {
            return;
        }

        var doPrevent = false;
        event = event || window.event;
        var key = event.keyCode;
        if (!keys[key]) {
            keys[key] = true;
        }

        if (key === 113) {
            ENABLE_DEBUG = !ENABLE_DEBUG;
            debugText.visible = ENABLE_DEBUG;
        }

        moveTimer = 0;

        if (socket != null && socket.connected) {
            if (idleTime >= AFK_TIME_TILL_KICK_WARNING) {
                announcementText.visible = false;
                announcementText.text = '';
            }
        }

        if (currentMenu === 'lobby') {
            return true;
        }

        if (spectating && key === 17) {
            toggleCameraZ();
        }

        var chatTypingText = (player && player.canControl) ? player.chat : null;
        if (chatTypingText) {
            if (key === 8) {
                doPrevent = true;
                if (type_chat && current_type_chat.length >= 1) {
                    current_type_chat = current_type_chat.substring(0, current_type_chat.length - 1);
                }

                var types = ["text", "password", "file", "search", "email", "number", "date", "color", "datetime", "datetime-local", "month", "range", "search", "tel", "time", "url", "week"];
                var d = $(event.srcElement || event.target);
                var disabled = d.prop("readonly") || d.prop("disabled");
                if (!disabled) {
                    if (d[0].isContentEditable) {
                        doPrevent = false;
                    } else if (d.is("input")) {
                        var type = d.attr("type");
                        if (type) {
                            type = type.toLowerCase();
                        }
                        if (types.indexOf(type) > -1) {
                            doPrevent = false;
                        }
                    } else if (d.is("textarea")) {
                        doPrevent = false;
                    }
                }
            }

            chatTypingText.text = current_type_chat + "_";
            chatTypingText.visible = type_chat;
        }

        if (!type_chat) {
            if (key === 27) {
                if (game.gameMenuComponent) {
                    if (game.gameMenuComponent.shouldShowModal) {
                        game.gameMenuComponent.showModal(false);
                    } else {
                        game.gameMenuComponent.showModal(true);
                    }
                }
            } else if (socket && player) {
                if (key === 32) {
                    if (tutorialContainer && tutorialContainer.tutorialData && tutorialContainer.tutorialData.pause) {
                        continueTutorial();
                    } else if (!game.isTutorial) {
                        socket.emit('move', {
                            x: player.x + Math.cos(player.rotation - Math.PI / 2) * 20,
                            y: player.y + Math.sin(player.rotation - Math.PI / 2) * 20,
                            action: true
                        });
                    }
                } else if (key === 17) {
                    if (player && player.canControl) {
                        generateRadialMenu();
                        showRadialMenu = !showRadialMenu;
                    } else {
                        showRadialMenu = false;
                    }
                }

                if (key >= 49 && key <= 49+(radialItems.length-1)) {
                    let command = radialItems[key-49];
                    showRadialMenu = false;
                    if (command) {
                        performCommand(command);
                    }
                } else if (key >= 97 && key <= 97+(radialItems.length-1)) {
                    let command = radialItems[key-97];
                    showRadialMenu = false;
                    if (command) {
                        performCommand(command);
                    }
                }
            }

            if (game.isPlayScreen && key === 9) {
                doPrevent = true;
                showScoreboard();
            }
        }

        idleTime = 0;

        if (doPrevent) {
            event.preventDefault();
            return false;
        }
    });

    keyboardEventListenerObject.addEventListener('keypress', function (event) {
        if (inOverlayMenu) {
            return;
        }

        var key = event.keyCode;
        var char = String.fromCharCode(event.which);

        if (currentMenu === 'lobby') {
            return true;
        }

        var chatTypingText = (player && player.canControl) ? player.chat : null;
        if (chatTypingText) {
            if (key === 13 && !game.settings.disableChat) {
                if (type_chat) {
                    type_chat = false;
                    if (current_type_chat.trim().length > 0) {
                        game.chat(current_type_chat.trim());
                    }
                    current_type_chat = "";
                } else {
                    type_chat = true;
                }
            } else {
                if (type_chat && current_type_chat.length < 64) {
                    current_type_chat += char;
                }
            }

            chatTypingText.text = current_type_chat + "_";
            chatTypingText.visible = type_chat;
        }
    });

    keyboardEventListenerObject.addEventListener('keyup', function (event) {
        if (inOverlayMenu) {
            return;
        }

        event = event || window.event;
        var key = event.keyCode;
        if (keys[key]) {
            keys[key] = false;
        }

        if (socket != null && socket.connected) {
            if (idleTime >= AFK_TIME_TILL_KICK_WARNING) {
                announcementText.visible = false;
                announcementText.text = '';
            }
        }

        if (!type_chat) {
            if (key === 9) {
                hideScoreboard();
            }
        }

        idleTime = 0;
    });

    keyboardEventListenerObject.addEventListener('focusout', () => {
        let keyList = Object.keys(keys);
        for (let i=0; i<keyList.length; i++) {
            let key = parseInt(keyList[i]);
            if (keys[key]) {
                socket.emit('keyup', key);
                keys[key] = false;
            }
        }
    });

    function soundPlay(sound, entity, volume, callback, fadein) {
        let tso = {
            id: -1,
            entity: entity,
            volume: volume,
        };
        let ttso = soundUpdate(tso);

        if (ttso != null) {
            sound.play(null, function (id) {
                let so = {
                    id: id,
                    sound: sound,
                    volume: volume,
                    entity: entity,
                    started: Date.now()
                };

                if (fadein) {
                    so.fadein = 600;
                }

                so = soundUpdate(so);

                if (callback && so) {
                    callback(so);
                }
            });
        }
    }

    function soundUpdate(so) {
        let listener_pos = {
            x: camera.x + WIDTH / 2,
            y: camera.y + HEIGHT / 2,
            z: camera.z
        };

        if (player && player.valid) {
            listener_pos = {
                x: player.x,
                y: player.y,
                z: player.z
            };
        }

        let dist = Math.distanceBetween(so.entity, listener_pos);
        if (dist >= 1000 || so.entity.z !== listener_pos.z) {
            soundStop(so);
            return null;
        }

        let final_vol = 0;
        if (dist <= 100) {
            final_vol = so.volume;
        } else {
            let vol = so.volume - (dist / 2000);
            if (vol <= 0) {
                soundStop(so);
                return null;
            }
            final_vol = vol;
        }

        if (so.fadein) {
            let tdiff = (Date.now() - so.started) / so.fadein;
            if (tdiff <= 0.05) {
                final_vol = 0;
            } else if (tdiff < 1) {
                final_vol *= tdiff;
            }
        }

        if (so.id !== -1) {
            so.sound.volume(final_vol, so.id);
        }

        return so;
    }

    function soundStop(so) {
        if (so.id !== -1) {
            so.sound.stop(so.id);
        }
    }

    function getTeamString(team) {
        if (team === 0) {
            return 'Black';
        } else if (team === 1) {
            return 'Red';
        } else if (team === 2) {
            return 'Green';
        } else if (team === 3) {
            return 'Blue';
        } else if (team === 4) {
            return 'Yellow';
        } else if (team === 5) {
            return 'Orange';
        } else if (team === 6) {
            return 'Pink';
        } else if (team === 7) {
            return 'Cyan';
        }
        return 'None';
    }

    game.getMousePosition = () => {
        if (app.renderer.plugins.interaction && app.renderer.plugins.interaction.mouse && app.renderer.plugins.interaction.mouse.global) {
            let pos = app.renderer.plugins.interaction.mouse.global;
            let zoomRatio = WIDTH/(WIDTH*camera.zoom);
            if (isMobile || pos.x < -9000 || pos.y < -9000) {
                pos = {
                    x: mx,
                    y: my
                };
            }
            return {
                x: (pos.x + camera.x) * zoomRatio,
                y: (pos.y + camera.y) * zoomRatio
            };
        }

        return {
            x: 0,
            y: 0
        };
    };

    function useSandboxTool() {
        let gmp = game.getMousePosition();
        currentSandboxTool.pos = {
            x: gmp.x,
            y: gmp.y,
            z: camera.z
        };
        socket.emit('useSandboxTool', currentSandboxTool);
    }

    let sandboxTeam = 0;
    function performCommand(itemData) {
        if (itemData.fn) {
            itemData.fn();
            return;
        }

        if (game.isSandbox) {
            if (itemData.needsTeam) {
                var teamFn = function(team) {
                    return function() {
                        sandboxTeam = team;
                        itemData.needsTeam = false;
                        performCommand(itemData);
                    };
                };
                var items = [];
                for (var i=0; i<8; i++) {
                    items.push({
                        command: getTeamString(i),
                        fn: teamFn(i)
                    });
                }
                generateRadialMenu(items);
                showRadialMenu = true;
            } else {
                if (itemData.type === 'Create') {
                    currentSandboxTool = {
                        name: 'Create Tool: ' + itemData.command,
                        type: 'create',
                        data: {
                            entity: itemData.command,
                            team: sandboxTeam
                        }
                    };
                } else if (itemData.type === 'Terrain') {
                    currentSandboxTool = {
                        name: 'Terrain: ' + itemData.command,
                        type: 'terrain',
                        terrainType: itemData.command
                    };
                } else if (itemData.type === 'Weather') {
                    socket.emit('useSandboxTool', {
                        type: 'weather',
                        value: itemData.value
                    });
                } else if (itemData.type === 'CreateMenu') {
                    switch (itemData.command) {
                        case 'Ants':
                            generateRadialMenu([
                                {
                                    command: 'Worker',
                                    type: 'Create',
                                    needsTeam: true
                                },
                                {
                                    command: 'Soldier',
                                    type: 'Create',
                                    needsTeam: true
                                },
                                {
                                    command: 'Major',
                                    type: 'Create',
                                    needsTeam: true
                                },
                                {
                                    command: 'Acid',
                                    type: 'Create',
                                    needsTeam: true
                                },
                                {
                                    command: 'Queen',
                                    type: 'Create',
                                    needsTeam: true
                                }
                            ]);
                            showRadialMenu = true;
                            break;
                        case 'Bugs':
                            generateRadialMenu([
                                {
                                    command: 'Spider',
                                    type: 'Create'
                                },
                                {
                                    command: 'Centipede',
                                    type: 'Create'
                                },
                                {
                                    command: 'Bug',
                                    type: 'Create'
                                },
                                {
                                    command: 'Aphid',
                                    type: 'Create'
                                },
                            ]);
                            showRadialMenu = true;
                            break;
                        case 'Objects':
                            generateRadialMenu([
                                {
                                    command: 'Food',
                                    type: 'Create'
                                },
                                {
                                    command: 'Blue Food',
                                    type: 'Create'
                                },
                                {
                                    command: 'Red Food',
                                    type: 'Create'
                                },
                                {
                                    command: 'Brood',
                                    type: 'Create'
                                },
                                {
                                    command: 'Anthill',
                                    type: 'Create'
                                },
                                {
                                    command: 'Rock',
                                    type: 'Create'
                                },
                                {
                                    command: 'Plant',
                                    type: 'Create'
                                }
                            ]);
                            showRadialMenu = true;
                            break;
                        default:
                            console.error('Invalid CreateMenu command:', itemData.command);
                            break;
                    }
                } else {
                    switch (itemData.command) {
                        case 'Create':
                            generateRadialMenu([
                                {
                                    command: 'Ants',
                                    type: 'CreateMenu'
                                },
                                {
                                    command: 'Bugs',
                                    type: 'CreateMenu'
                                },
                                {
                                    command: 'Objects',
                                    type: 'CreateMenu'
                                }
                            ]);
                            showRadialMenu = true;
                            break;
                        case 'Remove':
                            currentSandboxTool = {
                                name: 'Remove Tool',
                                type: 'remove'
                            };
                            break;
                        case 'Terrain':
                            generateRadialMenu([
                                {
                                    command: 'Empty',
                                    type: 'Terrain'
                                },
                                {
                                    command: 'Dirt',
                                    type: 'Terrain'
                                },
                                {
                                    command: 'Rock',
                                    type: 'Terrain'
                                },
                                {
                                    command: '0% Moisture',
                                    type: 'Terrain'
                                },
                                {
                                    command: '50% Moisture',
                                    type: 'Terrain'
                                },
                                {
                                    command: '100% Moisture',
                                    type: 'Terrain'
                                }
                            ]);
                            showRadialMenu = true;
                            break;
                        case 'Weather':
                            generateRadialMenu([
                                {
                                    command: 'Clear',
                                    type: 'Weather',
                                    value: 'clear'
                                },
                                {
                                    command: 'Rain',
                                    type: 'Weather',
                                    value: 'rain'
                                },
                                {
                                    command: 'Thunderstorm',
                                    type: 'Weather',
                                    value: 'thunderstorm'
                                }
                            ]);
                            showRadialMenu = true;
                            break;
                        case 'Switch':
                            isSwitchingPlayer = true;
                            break;
                        case 'Time x5':
                            sandboxTimeSpedUp = true;
                            socket.emit('useSandboxTool', {
                                type: 'timestepChange',
                                enabled: true
                            });
                            break;
                        case 'Time x1':
                            sandboxTimeSpedUp = false;
                            socket.emit('useSandboxTool', {
                                type: 'timestepChange',
                                enabled: false
                            });
                            break;
                        case 'View Up/Down':
                            toggleCameraZ();
                            break;
                        default:
                            console.error('Command undefined:', itemData.command);
                            break;
                    }
                }
            }
        } else {
            switch (itemData.command) {
                case 'Switch':
                    isSwitchingPlayer = true;
                    break;
                case 'Select Follow':
                    isSelectingFollow = true;
                    break;
                case 'Commands':
                    generateRadialMenu([
                        {
                            command: 'Defend'
                        },
                        {
                            command: 'Stop Defend'
                        },
                        {
                            command: 'Forage'
                        },
                        {
                            command: 'Stay Home'
                        },
                        {
                            command: 'Attack'
                        }
                    ]);
                    showRadialMenu = true;
                    break;
                default:
                    socket.emit('command', itemData.command);
                    generateRadialMenu();
                    break;
            }
        }
    }

    var lastmx = 0;
    var lastmy = 0;
    var mdx = 0;
    var mdy = 0;
    var currentMouseButton = 0;
    var movingCamera = false;
    var downPosition = null;
    var lastTap = Date.now();
    var lastTapDown = Date.now();
    var tapTime = 250;
    var didAction = false;
    var showRadialMenu = false;
    var radialMenuData = null;
    var didSelectMenu = false;
    var eventPrefix = 'mouse';
    var tutorialTapCount = 0;
    var wasPaused = false;
    if (isMobile) {
        eventPrefix = 'pointer';
    }

    function continueTutorial() {
        if (tutorialContainer && tutorialContainer.tutorialData && tutorialContainer.tutorialData.pause) {
            socket.emit('tutorialContinue');
        }
    }

    var mouseEventListenerObject = app.view;
    mouseEventListenerObject.addEventListener(eventPrefix + 'down', function (e) {
        mx = e.clientX;
        my = e.clientY;
        lastmx = mx;
        lastmy = my;

        if (inOverlayMenu) {
            return;
        }

        if (tutorialContainer && tutorialContainer.tutorialData && tutorialContainer.tutorialData.pause) {
            wasPaused = true;
            if (currentMouseButton === 2) {
                continueTutorial();
                return;
            }

            if (Date.now() - lastTap < tapTime) {
                if (tutorialTapCount >= 1) {
                    tutorialTapCount = 0;
                    continueTutorial();
                    lastTap = Date.now()-5000;
                }
            }
            tutorialTapCount++;
            lastTap = Date.now();
            return;
        } else {
            tutorialTapCount = 0;
        }

        if (isMobile) {
            currentMouseButton = 0;
        } else {
            currentMouseButton = e.button;
            if (currentMouseButton === 2 && isSelectingFollow) {
                isSelectingFollow = false;
            }
        }

        if (socket != null && socket.connected) {
            let gmp = game.getMousePosition();
            if (currentMouseButton === 0) {
                if (spawnText && spawnText.visible && player) {
                    socket.emit('switchSpectate');
                } else if ((isSwitchingPlayer || isSelectingFollow) && ((player && player.valid && player.netData.alive) || game.isSandbox)) {
                    let closestDist = 10000;
                    let closestEntity = null;
                    for (let i = 0; i < entities.length; i++) {
                        let entity = entities[i];
                        let check = false;
                        let dist = Math.distanceBetween(gmp, entity);

                        if (game.isSandbox) {
                            check = entity.type === 'insect' && !entity.netData.name && entity.netData.alive && dist <= 35
                        } else {
                            check = (entity.subtype === 'ant_worker' || (isSwitchingPlayer && entity.subtype === 'ant_queen')) && !entity.netData.name && entity.netData.alive && entity.team === player.team && dist <= 35;
                        }

                        if (entity.valid && (game.isSandbox || (entity.z === player.z && entity !== player)) && check && dist < closestDist) {
                            closestEntity = entity;
                            closestDist = dist;
                        }

                        entity.filters = null;
                    }

                    if (closestEntity && closestEntity.valid) {
                        let command = 'switchPlayer';
                        if (isSelectingFollow) {
                            command = 'followPlayer';
                        }
                        socket.emit(command, closestEntity.serverId);
                        didAction = true;
                    }

                    isSwitchingPlayer = false;
                    if (isMobile) {
                        isSelectingFollow = false;
                    }
                } else if (showRadialMenu) {
                    for (let i = 0; i < radialItems.length; i++) {
                        let menuItem = radialItems[i];
                        let itemPos = {
                            x: radialMenuContainer.x + menuItem.x,
                            y: radialMenuContainer.y + menuItem.y
                        };

                        if (Math.distanceBetween(gmp, itemPos) <= 75) {
                            didAction = true;
                            didSelectMenu = true;
                            showRadialMenu = false;
                            performCommand(menuItem);
                            break;
                        }
                    }
                } else {
                    mouseDown = true;
                    moveTimer = 10;
                    /*
                    if (Date.now() - lastTap < tapTime && !was) {
                        gmp.action = true;
                        socket.emit('move', gmp);
                        didAction = true;
                    }
                    */
                }
            }
        }

        lastTapDown = Date.now();

        if (socket != null && !socket.connected && socket.forcedDisconnect) {
            window.location = '/';
        }
    });
    mouseEventListenerObject.addEventListener(eventPrefix + 'move', function (e) {
        mx = e.clientX;
        my = e.clientY;

        if (inOverlayMenu) {
            return;
        }

        mdx = lastmx - mx;
        mdy = lastmy - my;

        lastmx = mx;
        lastmy = my;

        if (mouseDown && currentMouseButton === 0 && spectating && !player && (Math.abs(mdx) > 1 || Math.abs(mdy) > 1)) {
            movingCamera = true;
            camera.x += mdx;
            camera.y += mdy;
        }

        if (socket != null && socket.connected) {
            if (idleTime >= AFK_TIME_TILL_KICK_WARNING) {
                announcementText.visible = false;
                announcementText.text = '';
            }
        }
        idleTime = 0;
    });

    mouseEventListenerObject.addEventListener(eventPrefix + 'up', function (e) {
        mx = e.clientX;
        my = e.clientY;

        if (inOverlayMenu) {
            return;
        }

        mouseDown = false;

        if (isMobile) {
            try {
                let fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
                if (!fullscreenElement) {
                    requestFullscreen(document.body);
                }
            } catch (e) {}
        }

        if (socket != null && socket.connected && !movingCamera && !wasPaused) {
            let gmp = game.getMousePosition();
            if ((currentMouseButton === 2 || Date.now() - lastTap < tapTime) && player) {
                gmp.action = true;
                socket.emit('move', gmp);
            }else if (currentMouseButton === 0 && game.isSandbox && currentSandboxTool) {
                if (!didAction && !showRadialMenu) {
                    useSandboxTool();
                }
            } else if (currentMouseButton === 2 && spectating) {
                toggleRadialMenu();
            } else if (currentMouseButton === 0 && player && !didSelectMenu) {
                let dist = Math.distanceBetween(gmp, player);
                if (dist <= 25) {
                    if (isSelectingFollow) {
                        isSelectingFollow = false;
                    } else {
                        if (player.canControl) {
                            showRadialMenu = !showRadialMenu;
                            if (showRadialMenu) {
                                generateRadialMenu();
                            }
                        } else {
                            showRadialMenu = false;
                        }
                    }
                } else {
                    showRadialMenu = false;
                }

                if (!didAction && !showRadialMenu) {
                    socket.emit('move', gmp);
                }
            } else {
                if (!didSelectMenu) {
                    showRadialMenu = false;
                }
            }
        }

        lastTap = Date.now();

        wasPaused = false;
        movingCamera = false;
        didSelectMenu = false;
        didAction = false;
        downPosition = null;
    });

    function toggleRadialMenu() {
        if (showRadialMenu) {
            showRadialMenu = false;
            radialMenuData = null;
        } else {
            showRadialMenu = true;
            generateRadialMenu();
            radialMenuData = {
                x: gmx,
                y: gmy
            };
            didSelectMenu = true;
        }
    }

    game.tryFullscreen = function() {
        try {
            var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
            if (!fullscreenElement) {
                requestFullscreen(document.body);
            }
        } catch (e) {}
    };

    function requestFullscreen(element) {
        // Supports most browsers and their versions.
        var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;

        if (requestMethod) { // Native full screen.
            requestMethod.call(element);
        } else if (typeof window.ActiveXObject !== "undefined") { // Older IE.
            var wscript = new ActiveXObject("WScript.Shell");
            if (wscript !== null) {
                wscript.SendKeys("{F11}");
            }
        }
    }

    loadAssets();

    function getTeamTint(team) {
        var tintColor = 0xFFFFFF;
        switch (team) {
            case 0:
                tintColor = 0x888888;
                break;
            case 1:
                tintColor = 0xFF2222;
                break;
            case 2:
                tintColor = 0x22FF22;
                break;
            case 3:
                tintColor = 0x2222FF;
                break;
            case 4:
                tintColor = 0xFFEC00;
                break;
            case 5:
                tintColor = 0xFF8600;
                break;
            case 6:
                tintColor = 0xFF34CE;
                break;
            case 7:
                tintColor = 0x00FFFC;
                break;
        }
        return tintColor;
    }

    function getTeamHex(team) {
        var tintColor = '#000000';
        switch (team) {
            case 0:
                tintColor = '#727272';
                break;
            case 1:
                tintColor = '#d61d1d';
                break;
            case 2:
                tintColor = '#1ecc1e';
                break;
            case 3:
                tintColor = '#1c1cce';
                break;
            case 4:
                tintColor = '#cfbf00';
                break;
            case 5:
                tintColor = '#d16a00';
                break;
            case 6:
                tintColor = '#d12da7';
                break;
            case 7:
                tintColor = '#00FFFC';
                break;
        }
        return tintColor;
    }
    game.getTeamHex = getTeamHex;

    function getResourceTexture(type) {
        let resourceSpritesheet = loadSpritesheet(resources['resources'].texture, 32, 32);
        switch(type) {
            case 'blue':
                return resourceSpritesheet[3][0];
            case 'red':
                return resourceSpritesheet[0][1];
            case 'plant':
                return resourceSpritesheet[1][0];
            case 'meat':
                return resourceSpritesheet[2][0];
            case 'honeydew':
                return resourceSpritesheet[0][0];
            case 'twigs':
                return resourceSpritesheet[2][1];
            case 'water':
                return resourceSpritesheet[1][1];
        }
        return resourceSpritesheet[1][0];
    }

    var antAnimHeadOffset = [
        0,
        -1,
        -2.5,
        -1,
        0,
        1,
        2.5,
        1
    ];
    var antAnimOffset = [
        0,
        1,
        2.5,
        1,
        0,
        -1,
        -2.5,
        -1
    ];

    function createInsect(serverId, subtype, x, y, z, width, height, team, netData) {
        var entity = createEntity(serverId, 'insect', subtype, x, y, z, team, netData);
        entity.frame = 0;
        entity.animation = 0;

        var sprite = new PIXI.Sprite();
        sprite.width = width;
        sprite.height = height;
        sprite.anchor.set(0.5);
        entity.sprite = sprite;
        entity.addChild(sprite);

        var zOffset = 0;
        if (netData && netData.zOffset) {
            zOffset = netData.zOffset;
        }
        var spiderType = 0;
        var hasAntenna = false;
        var canCarry = true;
        var canHaveCosmetics = false;
        var spritesheet = null;
        if (subtype === 'ant_worker') {
            if (entity.netData.soldier) {
                spritesheet = loadSpritesheet(resources['ant_soldier'].texture, 128, 128);
            } else {
                spritesheet = loadSpritesheet(resources['ant_worker'].texture, 128, 128);
            }
            entity.frame = Math.floor(Math.random()*8);
            canCarry = true;
            hasAntenna = true;
            canHaveCosmetics = true;
        } else if (subtype === 'ant_queen') {
            spritesheet = loadSpritesheet(resources['ant_queen'].texture, 128, 128);
            canCarry = true;
            hasAntenna = true;
            canHaveCosmetics = true;
        } else if (subtype === 'spider') {
            if (Math.random() > 0.6) {
                spiderType = 1;
                spritesheet = loadSpritesheet(resources['spider'].texture, 350, 350);
            } else {
                spiderType = 0;
                spritesheet = loadSpritesheet(resources['spider2'].texture, 350, 350);
            }
        } else if (subtype === 'bug') {
            if (entity.netData.bugType === 'centipede') {
                spritesheet = loadSpritesheet(resources['centipede'].texture, 128, 128);
                entity.frame = zOffset%6;
            } else {
                spritesheet = loadSpritesheet(resources['bug'].texture, 420, 420);
            }
        } else if (subtype === 'beetle') {
            spritesheet = loadSpritesheet(resources['beetle'].texture, 385, 385);
        } else if (subtype === 'grub') {
            sprite.texture = resources['grub'].texture;
        }  else {
            console.error('Invalid insect subtype:', subtype);
        }
        if (spritesheet) {
            sprite.texture = spritesheet[parseInt(entity.frame)][entity.animation];
        }

        if (canCarry) {
            var carriedObjectSprite = new PIXI.Sprite();
            carriedObjectSprite.position.y = -(height*0.48);
            if (height === 105) {
                carriedObjectSprite.position.y = -(height*0.44);
            }
            carriedObjectSprite.width = 45;
            carriedObjectSprite.height = 45;
            carriedObjectSprite.rotation = Math.random() * Math.PI * 2;
            carriedObjectSprite.anchor.set(0.5);
            entity.carriedObjectSprite = carriedObjectSprite;
            entity.addChild(carriedObjectSprite);
            entity.carriedObjectSprite.visible = false;
        }

        var color = 0xCCCCCC;
        var antennaSpritesheet = null;
        if (hasAntenna) {
            antennaSpritesheet = loadSpritesheet(resources['antenna'].texture, 128, 64);

            var antennaSprite = new PIXI.Sprite(antennaSpritesheet[0][0]);
            if (subtype === 'ant_worker') {
                antennaSprite.position.y = -height * 0.45;
                antennaSprite.width = width * 0.75;
                antennaSprite.height = height * 0.4;
            } else {
                antennaSprite.position.y = -height * 0.56;
                antennaSprite.width = width;
                antennaSprite.height = height * 0.5;
            }
            antennaSprite.anchor.set(0.5);
            entity.antennaSprite = antennaSprite;
            entity.addChild(antennaSprite);

            var colorTeam = entity.team;
            if (entity.netData.fakeTeam !== null && entity.netData.fakeTeam !== undefined) {
                colorTeam = entity.netData.fakeTeam;
            }
            var color = getTeamTint(colorTeam);
            sprite.tint = color;
            antennaSprite.tint = color;
        }

        let queenWingsSpritesheet = loadSpritesheet(resources['ant_queen_wings'].texture, 128, 128);
        if (canHaveCosmetics) {
            if (subtype === 'ant_queen') {
                let wingsSprite = new PIXI.Sprite(queenWingsSpritesheet[0][0]);
                wingsSprite.position.y = 0;
                wingsSprite.width = width;
                wingsSprite.height = height;
                wingsSprite.anchor.set(0.5);
                entity.wingsSprite = wingsSprite;
                entity.addChild(wingsSprite);
                entity.wingsSprite.visible = entity.netData.newQueen;
            }

            entity.cosmeticsContainer = new PIXI.Container();
            entity.cosmeticsContainer.visible = false;
            entity.addChild(entity.cosmeticsContainer);

            var cosmeticsHeadSprite = new PIXI.Sprite();
            cosmeticsHeadSprite.rotation = 0;
            cosmeticsHeadSprite.anchor.set(0.5);
            cosmeticsHeadSprite.visible = false;
            entity.cosmeticsHeadSprite = cosmeticsHeadSprite;
            entity.cosmeticsContainer.addChild(cosmeticsHeadSprite);

            var cosmeticsAbdomenSprite = new PIXI.Sprite();
            cosmeticsAbdomenSprite.rotation = 0;
            cosmeticsAbdomenSprite.anchor.set(0.5);
            cosmeticsAbdomenSprite.visible = false;
            entity.cosmeticsAbdomenSprite = cosmeticsAbdomenSprite;
            entity.cosmeticsContainer.addChild(cosmeticsAbdomenSprite);

            var cosmeticsThoraxSprite = new PIXI.Sprite();
            cosmeticsThoraxSprite.rotation = 0;
            cosmeticsThoraxSprite.anchor.set(0.5);
            cosmeticsThoraxSprite.visible = false;
            entity.cosmeticsThoraxSprite = cosmeticsThoraxSprite;
            entity.cosmeticsContainer.addChild(cosmeticsThoraxSprite);
        }

        var guiSpriteContainer = new PIXI.Container();
        guiSpriteContainer.broodCost = [];
        guiSpriteContainer.getZIndex = function () {
            return entity.getZIndex() - 100;
        };
        entity.guiSpriteContainer = guiSpriteContainer;
        app.cstage.addChild(guiSpriteContainer);

        var guiSprite = new PIXI.Sprite(guiSpritesheet[0][0]);
        guiSprite.width = 40;
        guiSprite.height = 40;
        guiSprite.anchor.set(0.5);
        entity.guiSprite = guiSprite;
        guiSpriteContainer.addChild(guiSprite);

        if (!entity.netData.centipedeType || entity.netData.centipedeType === 'head') {
            var chat = new PIXI.Text();
            chat.position.y = -40;
            chat.anchor.x = 0.5;
            chat.visible = false;
            chat.style.fill = 0xFFFFFF;
            chat.style.fontSize = 20;
            entity.chat = chat;
            guiSpriteContainer.addChild(chat);
        }

        if (hasAntenna) {
            var name = new PIXI.Text();
            name.position.y = 1;
            name.anchor.x = 0.5;
            name.visible = false;
            name.style.fill = 0xFFFFFF;
            name.style.fontSize = 15;
            entity.name = name;
            guiSpriteContainer.addChild(name);

            var devtag = new PIXI.Sprite(tagsSpritesheet[0][0]);
            devtag.position.y = -5;
            devtag.scale.set(0.75);
            devtag.visible = false;
            devtag.anchor.set(0.5);
            entity.devtag = devtag;
            guiSpriteContainer.addChild(devtag);
        }

        entity.updateFilters = function() {
            if (entity.netData && entity.netData.name) {
                entity.filters = [new PIXI.filters.GlowFilter({
                    distance: 8,
                    outerStrength: 1,
                    innerStrength: 0.25,
                    color: color,
                    quality: 0.1
                })];
            } else {
                entity.filters = null;
            }
        };
        entity.updateFilters();

        if (entity.subtype === 'ant_queen') {
            entity.setBroodCost = function (cost) {
                for (let i = 0; i < guiSpriteContainer.broodCost.length; i++) {
                    let bcsprite = guiSpriteContainer.broodCost[i];
                    guiSpriteContainer.removeChild(bcsprite);
                }

                if (teamInfo && teamInfo.id === entity.team && cost) {
                    entity.netData.broodCost = cost;

                    if (entity.netData.broodCost) {
                        let keys = Object.keys(entity.netData.broodCost);

                        let spriteSize = 20;
                        let foodSprites = [];
                        for (let i = 0; i < keys.length; i++) {
                            let foodType = keys[i];
                            let amount = entity.netData.broodCost[foodType];
                            for (let j = 0; j < amount; j++) {
                                let foodSprite = new PIXI.Sprite(getResourceTexture(foodType));
                                foodSprite.width = spriteSize;
                                foodSprite.height = spriteSize;
                                foodSprite.x = foodSprites.length * spriteSize;
                                foodSprite.y = 25;
                                guiSpriteContainer.broodCost.push(foodSprite);
                                guiSpriteContainer.addChild(foodSprite);
                                foodSprites.push(foodSprite);
                            }
                        }

                        for (let i=0; i<foodSprites.length; i++) {
                            let foodSprite = foodSprites[i];
                            foodSprite.x -= (spriteSize*foodSprites.length)/2;
                        }
                    }
                } else {
                    entity.netData.broodCost = null;
                }
            };
            entity.setBroodCost(entity.netData.broodCost);
        }

        entity.setNewQueen = function(newQueen) {
            entity.netData.newQueen = newQueen;
            entity.wingsSprite.visible = entity.netData.newQueen;
        };

        entity.changeName = function (newName) {
            entity.netData.name = newName.name;
            entity.netData.isDev = newName.isDev;
            entity.netData.settings = newName.settings;

            entity.updateFilters();

            try {
                if (entity.netData.settings) {
                    entity.cosmeticsContainer.visible = true;
                    if (entity.netData.settings.head && resources[entity.netData.settings.head.texture]) {
                        entity.cosmeticsHeadSprite.visible = true;
                        let cw = entity.netData.settings.head.width ? entity.netData.settings.head.width : 32;
                        let ch = entity.netData.settings.head.height ? entity.netData.settings.head.height : 32;
                        let spritesheet = loadSpritesheet(resources[entity.netData.settings.head.texture].texture, cw, ch);
                        entity.cosmeticsHeadSprite.texture = spritesheet[entity.netData.settings.head.frame][entity.netData.settings.head.animation];

                        let scale = entity.netData.settings.head.scale ? entity.netData.settings.head.scale : 1;
                        let offsetscaley = 0.22;
                        if (subtype === 'ant_queen') {
                            offsetscaley = 0.35;
                        }
                        if (subtype === 'ant_worker' && !entity.netData.soldier) {
                            scale *= 0.85;
                        }
                        if (subtype === 'ant_worker' && entity.netData.soldier && entity.width > 80) {
                            offsetscaley = 0.26;
                            scale *= 1.3;
                        }
                        offsetscaley *= entity.netData.settings.head.offsety ? entity.netData.settings.head.offsety : 1;
                        entity.cosmeticsHeadSprite.position.y =  -(height*offsetscaley);
                        entity.cosmeticsHeadSprite.width = cw*scale;
                        entity.cosmeticsHeadSprite.height = ch*scale;
                    } else {
                        entity.cosmeticsHeadSprite.visible = false;
                    }

                    if (entity.netData.settings.thorax && resources[entity.netData.settings.thorax.texture]) {
                        entity.cosmeticsThoraxSprite.visible = true;
                        let cw = entity.netData.settings.thorax.width ? entity.netData.settings.thorax.width : 32;
                        let ch = entity.netData.settings.thorax.height ? entity.netData.settings.thorax.height : 32;
                        let spritesheet = loadSpritesheet(resources[entity.netData.settings.thorax.texture].texture, cw, ch);
                        entity.cosmeticsThoraxSprite.texture = spritesheet[entity.netData.settings.thorax.frame][entity.netData.settings.thorax.animation];

                        let scale = entity.netData.settings.thorax.scale ? entity.netData.settings.thorax.scale : 1;
                        let offsetscaley = 1;
                        if (subtype === 'ant_worker' && !entity.netData.soldier) {
                            scale *= 0.8;
                        }
                        if (subtype === 'ant_worker' && entity.netData.soldier && entity.width > 80) {
                            scale *= 1.25;
                        }
                        offsetscaley *= entity.netData.settings.thorax.offsety ? entity.netData.settings.thorax.offsety : 0.02;
                        entity.cosmeticsThoraxSprite.position.y =  -(height*offsetscaley);
                        entity.cosmeticsThoraxSprite.width = cw*scale;
                        entity.cosmeticsThoraxSprite.height = ch*scale;
                    } else {
                        entity.cosmeticsThoraxSprite.visible = false;
                    }

                    if (entity.netData.settings.abdomen && resources[entity.netData.settings.abdomen.texture]) {
                        entity.cosmeticsAbdomenSprite.visible = true;
                        let cw = entity.netData.settings.abdomen.width ? entity.netData.settings.abdomen.width : 32;
                        let ch = entity.netData.settings.abdomen.height ? entity.netData.settings.abdomen.height : 32;
                        let spritesheet = loadSpritesheet(resources[entity.netData.settings.abdomen.texture].texture, cw, ch);
                        entity.cosmeticsAbdomenSprite.texture = spritesheet[entity.netData.settings.abdomen.frame][entity.netData.settings.abdomen.animation];

                        let scale = entity.netData.settings.abdomen.scale ? entity.netData.settings.abdomen.scale : 1;
                        let offsetscaley = 0.22;
                        if (subtype === 'ant_worker' && !entity.netData.soldier) {
                            offsetscaley = 0.16;
                            scale *= 0.75;
                        }

                        if (subtype === 'ant_worker' && entity.netData.soldier && entity.width <= 80) {
                            scale *= 0.7;
                            offsetscaley = 0.16;
                        }
                        if (subtype === 'ant_worker' && entity.netData.soldier && entity.width > 80) {
                            offsetscaley = 0.16;
                            scale *= 1.15;
                        }
                        offsetscaley *= entity.netData.settings.abdomen.offsety ? entity.netData.settings.abdomen.offsety : 1;
                        entity.cosmeticsAbdomenSprite.position.y =  (height*offsetscaley);
                        entity.cosmeticsAbdomenSprite.width = cw*scale;
                        entity.cosmeticsAbdomenSprite.height = ch*scale;
                    } else {
                        entity.cosmeticsAbdomenSprite.visible = false;
                    }
                } else {
                    if (entity.cosmeticsContainer) {
                        entity.cosmeticsContainer.visible = false;
                    }
                }
            } catch (e) {
                if (entity.cosmeticsContainer) {
                    entity.cosmeticsContainer.visible = false;
                    console.error('Failed to load cosmetics:', e);
                }
            }
        };
        if (entity.netData && entity.netData.name) {
            entity.changeName(entity.netData);
        }

        var walkSound = null;
        var antennaFrame = parseInt(Math.random() * 8);
        var antennaSpeed = 0.2;
        var oldTick = entity.tick;
        var doAttack = false;
        var pheromoneTick = Math.round(30 * Math.random());
        var damageTick = 0;
        var flyingFrames = 0;
        entity.tick = function(delta) {
            if (entity.name) {
                if (game.roundEnded) {
                    entity.name.text = entity.netData.name;
                    entity.name.visible = true;
                    entity.devtag.visible = entity.name.visible && entity.netData.isDev && !game.isSingleplayer;
                } else if (entity.netData && entity.netData.name && entity.netData.alive && (entity !== player || !player.canControl)) {
                    entity.name.text = entity.netData.name;
                    entity.name.visible = Math.distanceBetween({x: gmx, y: gmy}, entity) < 32;
                    entity.devtag.visible = entity.name.visible && entity.netData.isDev && !game.isSingleplayer;
                } else {
                    entity.name.visible = false;
                    entity.devtag.visible = false;
                }
            }

            if (entity.netData.alive) {
                if (subtype === 'ant_queen' && entity.wingsSprite) {
                    if (entity.netData.flying) {
                        flyingFrames += 0.5;
                        if (Math.floor(flyingFrames) >= 2) {
                            flyingFrames = 0;
                        }
                        entity.wingsSprite.texture = queenWingsSpritesheet[Math.floor(flyingFrames)][0];
                    } else {
                        entity.wingsSprite.texture = queenWingsSpritesheet[0][0];
                    }
                }

                /*
                if (subtype === 'ant_worker' && entity.carriedObject === 'food' && entity.z === 0 && (Math.abs(entity.dx) > 0.5 || Math.abs(entity.dy) > 0.5)) {
                    if (pheromoneTick <= 0) {
                        createEffect('pheromone', entity.x, entity.y, entity.z, 45, 45, {color: color});
                        pheromoneTick = 35 + Math.round(20 * Math.random());
                    } else {
                        pheromoneTick--;
                    }
                }
                */

                if (entity.netData.broodCost && (!teamInfo || entity.team !== teamInfo.id)) {
                    entity.setBroodCost(null);
                }

                if (entity.netData && entity.netData.digging && subtype === 'ant_worker') {
                    entity.animation = 1;
                    entity.frame += 0.22;
                    if (parseInt(entity.frame) >= 8) {
                        entity.frame = 0;
                        soundPlay(sounds['wood_hit' + (parseInt(Math.random() * 4) + 1)], entity, 0.02);
                    }

                    if (walkSound) {
                        soundStop(walkSound);
                        walkSound = null;
                    }
                } else if (doAttack && subtype !== 'ant_queen' && !(subtype === 'bug' && entity.netData && entity.netData.bugType === 'centipede')) {
                    if (subtype === 'spider' || subtype === 'bug' || subtype === 'beetle') {
                        entity.animation = 1;
                        entity.frame += 0.22;
                        if (parseInt(entity.frame) >= 4) {
                            entity.frame = 0;
                            doAttack = false;
                        }
                    }

                    if (subtype === 'ant_worker' || subtype === 'ant_queen') {
                        entity.animation = 1;
                        entity.frame += 0.22;
                        if (parseInt(entity.frame) >= 8) {
                            entity.frame = 0;
                            doAttack = false;
                        }
                    }
                } else {
                    if (sounds.walk && !entity.netData.flying && (Math.abs(entity.dx) >= 0.5 || Math.abs(entity.dy) >= 0.5) && entity.netData.centipedeType !== 'body') {
                        if (!walkSound) {
                            soundPlay(sounds.walk, entity, 0.12, function(so) {
                                if (entity.valid) {
                                    walkSound = so;
                                } else {
                                    soundStop(so);
                                }
                            });
                        } else {
                            soundUpdate(walkSound);
                        }
                    } else {
                        if (walkSound) {
                            soundStop(walkSound);
                            walkSound = null;
                        }
                    }

                    if (subtype === 'ant_worker' || subtype === 'ant_queen') {
                        entity.animation = 0;
                        if ((Math.abs(entity.dx) >= 0.5 || Math.abs(entity.dy) >= 0.5) && !entity.netData.flying) {
                            entity.frame += 0.3 + ((Math.abs(entity.dx) + Math.abs(entity.dy)) * 0.04);
                        } else if (entity.netData.flying) {
                            entity.frame = 2;
                            entity.animation = 1;
                        }

                        if (parseInt(entity.frame) >= 8) {
                            entity.frame = 0;
                        }

                        if (entity.cosmeticsHeadSprite && entity.cosmeticsHeadSprite.visible) {
                            entity.cosmeticsHeadSprite.x = -antAnimHeadOffset[Math.floor(entity.frame)]*0.21;
                        }

                        if (entity.cosmeticsAbdomenSprite && entity.cosmeticsAbdomenSprite.visible) {
                            entity.cosmeticsAbdomenSprite.x = -antAnimOffset[Math.floor(entity.frame)]*0.5;
                        }
                    } else if (subtype === 'spider') {
                        entity.animation = 0;
                        if (Math.abs(entity.dx) >= 0.5 || Math.abs(entity.dy) >= 0.5) {
                            entity.frame += 0.2;
                        }

                        if (parseInt(entity.frame) >= 4) {
                            entity.frame = 0;
                        }
                    } else if (subtype === 'bug') {
                        if (entity.netData && entity.netData.bugType === 'centipede') {
                            if (entity.netData.centipedeType === 'head') {
                                entity.animation = 0;
                                entity.frame += 0.12;
                                if (parseInt(entity.frame) >= 6) {
                                    entity.frame = 0;
                                }
                            } else if (entity.netData.centipedeType === 'tail') {
                                entity.animation = 0;
                                entity.frame = 6;
                            } else {
                                entity.animation = 1;
                                if (Math.abs(entity.dx) >= 0.5 || Math.abs(entity.dy) >= 0.5) {
                                    entity.frame += 0.1 + ((Math.abs(entity.dx) + Math.abs(entity.dy)) * 0.04);
                                }

                                if (parseInt(entity.frame) >= 6) {
                                    entity.frame = 0;
                                }
                            }
                        } else {
                            if (Math.abs(entity.dx) >= 0.5 || Math.abs(entity.dy) >= 0.5) {
                                entity.frame += 0.18;
                            }

                            if (parseInt(entity.frame) >= 4) {
                                entity.frame = 0;
                            }
                        }
                    } else if (subtype === 'beetle') {
                        entity.animation = 0;
                        if (Math.abs(entity.dx) >= 0.5 || Math.abs(entity.dy) >= 0.5) {
                            entity.frame += 0.18;
                        }

                        if (parseInt(entity.frame) >= 4) {
                            entity.frame = 0;
                        }
                    }
                }

                if (hasAntenna) {
                    antennaFrame += antennaSpeed;
                    if (parseInt(antennaFrame) >= 8) {
                        antennaFrame = 0;
                        antennaSpeed = 0.08 + (Math.random() / 6);
                    }


                    entity.antennaSprite.texture = antennaSpritesheet[parseInt(antennaFrame)][0];
                }
            } else {
                guiSprite.visible = false;
            }

            if (chat && chat.visible) {
                if (chat.removeChat < Date.now()) {
                    chat.removeChat = null;
                    if (!type_chat) {
                        chat.visible = false;
                    }
                }
            }

            if (damageTick > 0) {
                damageTick--;
                sprite.tint = 0xFFFFFF;
            } else {
                sprite.tint = color;
            }

            try {
                sprite.texture = spritesheet[parseInt(entity.frame)][entity.animation];
            } catch (e) {}

            oldTick(delta);

            guiSpriteContainer.visible = entity.isVisible() && entity.netData.alive;
            guiSprite.visible = teamInfo && teamInfo.id === entity.team && entity.netData.hungry;
            if (guiSpriteContainer.visible) {
                guiSpriteContainer.x = entity.x;
                if (game.roundEnded) {
                    guiSpriteContainer.y = entity.y + 35;
                } else {
                    guiSpriteContainer.y = entity.y - 30;
                }
            }
        };

        entity.changeGrabbedObject = function (object, disableSound) {
            entity.carriedObject = object ? object.subtype : null;
            if (object) {
                if (object.subtype === 'food') {
                    entity.carriedObjectSprite.texture = getResourceTexture(object.netData.foodType);
                    entity.carriedObjectSprite.visible = true;
                } else if (object.subtype === 'material') {
                    entity.carriedObjectSprite.texture = getResourceTexture(object.netData.matType);
                    entity.carriedObjectSprite.visible = true;
                } else if (object.subtype === 'aphid') {
                    entity.carriedObjectSprite.texture = resources['aphid'].texture;
                    entity.carriedObjectSprite.visible = true;
                } else if (object.subtype === 'dirt') {
                    entity.carriedObjectSprite.texture = resources['dirt'].texture;
                    entity.carriedObjectSprite.visible = true;
                } else if (object.subtype === 'brood') {
                    var broodSpritesheet = loadSpritesheet(resources['brood'].texture, 64, 64);
                    entity.carriedObjectSprite.texture = broodSpritesheet[0][object.data];
                    entity.carriedObjectSprite.visible = true;
                } else if (object.subtype === 'wreath') {
                    if (resources['wreath']) {
                        entity.carriedObjectSprite.texture = resources['wreath'].texture;
                    } else {
                        entity.carriedObjectSprite.texture = resources['white'].texture;
                    }
                    entity.carriedObjectSprite.visible = true;
                }

                if (object.size) {
                    carriedObjectSprite.width = object.size;
                    carriedObjectSprite.height = object.size;
                } else {
                    carriedObjectSprite.width = 45;
                    carriedObjectSprite.height = 45;
                }
            } else {
                entity.carriedObjectSprite.visible = false;
            }

            if (!disableSound) {
                soundPlay(sounds['wood_hit' + (parseInt(Math.random() * 4) + 1)], entity, 0.15);
            }
        };

        if (netData.carriedObject) {
            entity.changeGrabbedObject(netData.carriedObject, true);
        }

        entity.setAIState = function(state) {
            entity.netData.name = state.state;
            entity.targetId = state.targetId;

            if (entity.aigfx) {
                app.cstage.removeChild(entity.aigfx);
            }

            if (entity.targetId && entityDictionary[entity.targetId]) {
                entity.aigfx = new PIXI.Graphics();
                entity.aigfx.lineStyle(2, '0xFF2222');
                entity.aigfx.moveTo(entity.x, entity.y);
                entity.aigfx.lineTo(entityDictionary[entity.targetId].x, entityDictionary[entity.targetId].y);
                entity.aigfx.getZIndex = () => {
                    return -10000;
                };
                app.cstage.addChild(entity.aigfx);
            }
        };

        entity.setDigging = function(digging) {
            entity.netData.digging = digging;
        };

        entity.performAttack = function (data) {
            doAttack = true;
            entity.frame = 0;
            if (data.targetX && data.targetY) {
                entity.rotation = Math.angleBetween(entity, {x: data.targetX, y: data.targetY}) + Math.PI/2;
                if (entity.states && entity.states[0]) {
                    entity.states[0].rotation = entity.rotation;
                }
            }
            if (data.weapon === 'acid' && data.targetX && data.targetY) {
                soundPlay(sounds['acid'], entity, 0.15);
                createEffect('acid', entity.x, entity.y, entity.z, 30, 30, {
                    targetX: data.targetX,
                    targetY: data.targetY
                });
            }
        };

        entity.damage = function() {
            soundPlay(sounds['wood_hit' + (parseInt(Math.random() * 4) + 1)], entity, 0.15);
            damageTick = 5;
        };

        entity.kill = function () {
            entity.netData.alive = false;
            entity.showDead();

            if (entity === player) {
                game.onPlayerDead();
            }

            if (walkSound) {
                soundStop(walkSound);
                walkSound = null;
            }
        };

        entity.onRemove = function () {
            app.cstage.removeChild(entity.guiSpriteContainer);

            if (entity.aigfx) {
                app.cstage.removeChild(entity.aigfx);
                entity.aigfx = null;
            }

            if (walkSound) {
                soundStop(walkSound);
                walkSound = null;
            }
        };

        entity.showDead = function () {
            if (hasAntenna) {
                entity.antennaSprite.visible = false;
            }
            if (canCarry) {
                entity.carriedObjectSprite.visible = false;
            }

            if (entity.wingsSprite) {
                entity.wingsSprite.visible = false;
            }

            guiSprite.visible = false;

            if (entity.subtype === 'ant_worker') {
                entity.frame = 0;
                entity.animation = 3;
            } else if (entity.subtype === 'spider') {
                entity.frame = 0;
                entity.animation = 2;
            } else if (entity.subtype === 'bug') {
                if (entity.netData.bugType === 'centipede') {
                    if (entity.netData.centipedeType === 'head') {
                        entity.frame = 7;
                        entity.animation = 0;
                    } else if (entity.netData.centipedeType === 'tail') {
                        entity.frame = 7;
                        entity.animation = 1;
                    }  else {
                        entity.frame = 6;
                        entity.animation = 1;
                    }
                } else {
                    entity.frame = 0;
                    entity.animation = 1;
                }
            } else if (entity.subtype === 'beetle') {
                entity.frame = 0;
                entity.animation = 1;
            } else {
                entity.frame = 1;
                entity.animation = 1;
            }
        };

        if (!entity.netData.alive) {
            entity.showDead();
        }

        entity.getZIndex = function () {
            if (!entity.netData.alive) {
                return (-entity.y + 200);
            } else if (entity.netData.flying) {
                return -entity.y - 2000;
            } else if (subtype === 'spider' || subtype === 'bug' || subtype === 'beetle') {
                return (-entity.y - 200) - zOffset;
            } else {
                return -entity.y - zOffset;
            }
        };

        return entity;
    }

    function createObject(serverId, subtype, x, y, z, width, height, team, netData) {
        var entity = createEntity(serverId, 'object', subtype, x, y, z, team, netData);
        if (subtype === 'stick') {
            entity.clientsideOnly = true;
        }

        if (subtype === 'rock' || subtype === 'stick') {
            let shadow = new PIXI.Sprite();
            shadow.tint = 0x000000;
            shadow.width = width;
            shadow.height = height;
            shadow.alpha = 0.5;
            shadow.anchor.set(0.5);
            entity.shadow = shadow;
            entity.addChild(shadow);
        }

        var sprite = new PIXI.Sprite();
        sprite.width = width;
        sprite.height = height;
        sprite.anchor.set(0.5);
        entity.sprite = sprite;
        entity.addChild(sprite);

        let subEntity = null;

        let lookUnderDist = 250;
        entity.canLookUnder = false;
        var spritesheet = null;
        if (subtype === 'anthill') {
            sprite.texture = resources['anthill'].texture;

            var sprite2 = new PIXI.Sprite(resources['anthill_below'].texture);
            sprite2.y = -20;
            sprite2.width = width;
            sprite2.height = height;
            sprite2.anchor.set(0.5);
            entity.sprite2 = sprite2;
            entity.addChild(sprite2);
        } else if (subtype === 'food') {
            sprite.texture = getResourceTexture(netData.foodType);
        } else if (subtype === 'material') {
            sprite.texture = getResourceTexture(netData.matType);
        } else if (subtype === 'wreath') {
            if (resources['wreath'] && resources['wreath'].texture) {
                sprite.texture = resources['wreath'].texture;
            } else {
                sprite.texture = resources['white'].texture;
            }
        } else if (subtype === 'brood') {
            spritesheet = loadSpritesheet(resources['brood'].texture, 64, 64);
            sprite.texture = spritesheet[0][0];
        } else if (subtype === 'rock') {
            spritesheet = [
                [resources['rock1'].texture, resources['rock2'].texture, resources['rock3'].texture, resources['rock4'].texture]
            ];
            sprite.texture = spritesheet[0][netData.rockType];
            entity.shadow.texture = sprite.texture;
        } else if (subtype === 'object_hide') {
            if (netData.sw && netData.sh) {
                spritesheet = loadSpritesheet(resources[netData.sprite].texture, netData.sw, netData.sh);
                sprite.texture = spritesheet[netData.sy][netData.sx];
            } else {
                sprite.texture = resources[netData.sprite].texture;
            }
            entity.canLookUnder = true;
        } else if (subtype === 'object_solid') {
            sprite.texture = resources[netData.sprite].texture;
        } else if (subtype === '') {
            spritesheet = loadSpritesheet(resources['brood'].texture, 64, 64);
            sprite.texture = spritesheet[0][0];
        } else if (subtype === 'stick') {
            spritesheet = loadSpritesheet(resources['sticks'].texture, 512, 128);
            sprite.texture = spritesheet[0][netData.stickType];
            entity.shadow.texture = sprite.texture;
        } else if (subtype === 'plant') {
            spritesheet = loadSpritesheet(resources['clover'].texture, 64, 64);
            sprite.texture = spritesheet[0][0];
            entity.canLookUnder = true;
            lookUnderDist = width;

            entity.leafDropShadowFilter = new PIXI.filters.DropShadowFilter({
                rotation: 90,
                distance: height*0.8,
                alpha: 0.175
            });

            let plantStalk = new PIXI.Sprite(spritesheet[1][0]);
            plantStalk.y = -height*0.15;
            plantStalk.width = width;
            plantStalk.height = height;
            plantStalk.anchor.set(0.5, 0.85);
            entity.plantStalk = plantStalk;

            let leafCount = netData.leafCount;
            entity.leaves = [];
            for (let i=0; i<leafCount; i++) {
                let leaf = new PIXI.Sprite(spritesheet[0][netData.foodSource ? 2 : 1]);
                leaf.nightValCloseTime = 0.5 + (Math.random() * 0.3);
                leaf.winterValCloseTime = 0.05 + (Math.random() * 0.1);
                leaf.x = 0;
                leaf.y = -height*0.35;
                leaf.width = width*0.35;
                leaf.height = height*0.35;
                leaf.baseRotation = ((((Math.PI*2)/leafCount) * i) + netData.leafRotation);
                leaf.anchor.set(0.5, 1);
                leaf.rotationOffset = Math.round(Math.random()*1000000);
                entity.leaves.push(leaf);
            }
            entity.addChild(plantStalk);

            for (let i=0; i<entity.leaves.length; i++) {
                let leaf = entity.leaves[i];
                entity.plantStalk.addChild(leaf);
            }
        } else if (subtype === 'aphid') {
            sprite.texture = resources['aphid'].texture;
        } else if (subtype === 'food_source') {
            if (netData && netData.foodSourceType === 'plant') {
                subEntity = createObject(-1, 'plant', x, y, z, width, height, team, {
                    leafCount: 3,
                    leafRotation: -0.1 + (Math.random()*Math.PI*0.2),
                    foodSource: true
                });
                subEntity.qualityChanged();
            } else {
                spritesheet = loadSpritesheet(resources['spider2'].texture, 350, 350);
                sprite.texture = spritesheet[0][2];
            }
        } else {
            console.error('Invalid object subtype:', subtype);
        }

        if (entity.canLookUnder) {
            entity.viewDistOffset = 250;
        }

        if (subtype === 'brood') {
            var guiSpriteContainer = new PIXI.Container();
            guiSpriteContainer.getZIndex = function () {
                return entity.getZIndex() - 100;
            };
            entity.guiSpriteContainer = guiSpriteContainer;
            app.cstage.addChild(guiSpriteContainer);

            var guiSprite = new PIXI.Sprite(guiSpritesheet[0][0]);
            guiSprite.width = 40;
            guiSprite.height = 40;
            guiSprite.anchor.set(0.5);
            entity.guiSprite = guiSprite;
            guiSpriteContainer.addChild(guiSprite);
        }

        var frame = parseInt(Math.random() * 8);
        var frameSpeed = 0.2;
        var oldTick = entity.tick;
        var rotationSet = false;
        var rotationOffset = Math.round(Math.random()*1000000);
        var moveMod = 0;
        entity.tick = function(delta) {
            if (subtype === 'brood') {
                frame += frameSpeed;
                if (parseInt(frame) >= 8) {
                    frame = 0;
                    frameSpeed = 0.08 + (Math.random() / 6);
                }
                if (entity.netData && entity.netData.broodStage) {
                    sprite.texture = spritesheet[parseInt(frame)][entity.netData.broodStage];
                }
            }

            if (subtype === 'plant' && entity.visible) {
                let rotMod = 1;
                let weather = getWeather();
                if (weather && weatherVal) {
                    rotMod = 1 + (weatherVal * 1.5);
                }
                if (moveMod > 100) {
                    moveMod -= moveMod * 0.05;
                } else {
                    moveMod = 0;
                }

                if (entity.leafDropShadowFilter) {
                    let zoomRatio = WIDTH/(WIDTH*camera.zoom);
                    let camY = camera.y * zoomRatio;
                    let newAlpha = (entity.y - (camY+height))*0.001;
                    if (newAlpha < 0) {
                        newAlpha = 0;
                    }
                    if (newAlpha > 0.175) {
                        newAlpha = 0.175;
                    }
                    entity.leafDropShadowFilter.alpha = newAlpha;
                }

                if (!player && game.isSandbox && moveMod <= 10000 && (Math.abs(mdx) >= 5 || Math.abs(mdy) >= 5)) {
                    let gmp = game.getMousePosition();
                    let dist = Math.distanceBetween(entity, gmp);

                    if (dist < 100) {
                        moveMod = 20000;
                    }
                }

                if (moveMod <= 1000) {
                    for (let i = 0; i < entities.length; i++) {
                        let e = entities[i];
                        if (e.type === 'insect' && e.subtype === 'spider' && (Math.abs(e.dx) >= 2 || Math.abs(e.dy) >= 2)) {
                            let dist = Math.distanceBetween(entity, e);
                            if (dist <= 95) {
                                moveMod = 20000;
                                break;
                            }
                        }
                    }
                }

                if (currentSeason.type === 'winter') {
                    entity.plantStalk.visible = false;
                    entity.plantStalk.scale.set(1);
                } else if (nextSeason && nextSeason.type === 'winter') {
                    if (seasonVal >= 0.9) {
                        entity.plantStalk.visible = false;
                        entity.plantStalk.scale.set(1);
                    } else if (seasonVal >= 0.5) {
                        let modSeasonVal = (seasonVal-0.5) * 2;
                        if (!entity.plantStalk.originalScale) {
                            entity.plantStalk.originalScale = entity.plantStalk.scale.x;
                        }
                        entity.plantStalk.scale.set(entity.plantStalk.originalScale * (1-modSeasonVal));
                    }
                }

                entity.plantStalk.rotation = -0.05 + Math.cos((Date.now() + moveMod + rotationOffset) / 3000) * (0.1 * rotMod);
                for (let i=0; i<entity.leaves.length; i++) {
                    let leaf = entity.leaves[i];
                    let frame = ((nightVal - leaf.nightValCloseTime)/(1-leaf.nightValCloseTime)) * 3;
                    if (frame < 0) {
                        frame = 0;
                    }
                    if (nextSeason && nextSeason.type === 'winter') {
                        frame += (((seasonVal + 0.25) - leaf.winterValCloseTime)/(1-leaf.winterValCloseTime)) * 3;
                    }
                    if (frame < 0) {
                        frame = 0;
                    }
                    if (frame > 3) {
                        frame = 3;
                    }

                    leaf.texture = spritesheet[Math.floor(frame)][netData.foodSource ? 2 : 1];
                    leaf.rotation = leaf.baseRotation + Math.cos((Date.now() + rotationOffset + leaf.rotationOffset) / 2000) * (0.05 * rotMod);
                }
            }

            oldTick(delta);

            if (entity.shadow && !rotationSet) {
                rotationSet = true;
                entity.shadow.x = Math.cos(-entity.rotation) * 10;
                entity.shadow.y = Math.sin(-entity.rotation) * 15;
            }

            if (entity.visible && entity.canLookUnder && entity.z === camera.z) {
                let dist = 1000;
                if (player) {
                    dist = Math.distanceBetween(entity, player);
                } else {
                    let gmp = game.getMousePosition();
                    dist = Math.distanceBetween(entity, gmp);
                }

                if (dist < lookUnderDist) {
                    entity.alpha = 0.5;
                }
            }

            if (subtype === 'anthill') {
                entity.sprite.visible = (camera.z === entity.z || camera.z <= 0);
                entity.sprite2.visible = camera.z === entity.z + 1;
                if (entity.netData.anthillSize < 2) {
                    let scale = 0.5 + ((entity.netData.anthillSize/2)/2);
                    entity.sprite.texture = resources['anthill_small'].texture;
                    entity.sprite.scale.x = scale;
                    entity.sprite.scale.y = scale;
                } else {
                    let scale = 0.5 + (((entity.netData.anthillSize-2)/4)/2);
                    if (scale > 1) {
                        scale = 1;
                    }
                    entity.sprite.texture = resources['anthill'].texture;
                    entity.sprite.scale.x = scale;
                    entity.sprite.scale.y = scale;
                }
            }

            if (entity.guiSpriteContainer) {
                entity.guiSpriteContainer.visible = entity.isVisible();
                entity.guiSprite.visible = entity.netData.hungry;

                if (entity.guiSpriteContainer.visible) {
                    guiSpriteContainer.x = entity.x;
                    guiSpriteContainer.y = entity.y - 30;
                }
            }
        };

        if (subtype === 'plant' || (subtype === 'object_hide' && netData.sprite === 'leaves')) {
            entity.updateFilters = function() {
                let filters = [];
                if (game.settings.quality === 'auto' || game.settings.quality === 'high') {
                    let fromSeason = seasonData[currentSeason.type];
                    if (fromSeason) {
                        if (fromSeason && fromSeason.plantFilters) {
                            filters = filters.concat(fromSeason.plantFilters);
                        }
                    }

                    if (nextSeason) {
                        let toSeason = seasonData[nextSeason.type];
                        if (toSeason && toSeason.plantFilters) {
                            filters = filters.concat(toSeason.plantFilters);
                        }
                    }
                }

                entity.filters = filters;
            };
        }

        entity.qualityChanged = function() {
            if (subtype === 'plant') {
                let filters = null;
                if (game.settings.quality === 'auto' || game.settings.quality === 'high') {
                    filters = [entity.leafDropShadowFilter];
                }

                entity.plantStalk.filters = filters;
                for (let i=0; i<entity.leaves.length; i++) {
                    let leaf = entity.leaves[i];
                    leaf.filters = filters;
                }
            }
        };

        entity.changeAnthillSize = function(anthillSize) {
            entity.netData.anthillSize = anthillSize;
        };

        entity.onRemove = function () {
            app.cstage.removeChild(entity.guiSpriteContainer);

            if (subEntity) {
                subEntity.remove();
                subEntity = null;
            }
        };

        entity.changeBroodStage = function (stage) {
            entity.netData.broodStage = stage;
        };

        entity.getZIndex = function () {
            if (subtype === 'plant') {
                return -entity.y - 1600;
            } else if (entity.canLookUnder) {
                return -entity.y - 1000;
            } else if (subtype === 'anthill') {
                if (camera.z === entity.z) {
                    return -entity.y + ((entity.netData.anthillSize >= 4) ? 3000 : 5000);
                } else {
                    return -entity.y + 8;
                }
            } else if (subtype === 'object_solid') {
                return -entity.y + 4200;
            } else if (subtype === 'food_source') {
                return -entity.y + 4200;
            } else if (subtype === 'rock') {
                return -entity.y + 4200;
            } else if (subtype === 'stick') {
                return -entity.y + 4500;
            } else {
                return -entity.y + 50;
            }
        };

        return entity;
    }

    function getWeather() {
        if (currentWeather) {
            return currentWeather;
        }
        return lastWeather;
    }

    function getMaxViewDistance() {
        let maxViewDist = MAX_VIEW_DIST_ABOVE;
        if (camera.z >= 1) {
            maxViewDist = MAX_VIEW_DIST_BELOW;
        } else {
            let weather = getWeather();
            if (weather && weather.type === 'rain') {
                let mod = 0.25 * weatherVal;
                maxViewDist = Math.round(maxViewDist * (1 - mod));
            }

            if (nightVal) {
                let mod = 0.25 * nightVal;
                maxViewDist = Math.round(maxViewDist * (1 - mod));
            }

            if (weather && weather.lightning && Date.now() - weather.lightning.start <= weather.lightning.lightEnd) {
                maxViewDist = MAX_VIEW_DIST_ABOVE;
            }
        }
        return maxViewDist;
    }

    let MAX_VIEW_DIST_ABOVE = 1500;
    let MAX_VIEW_DIST_BELOW = 450;
    function isCloseToPlayer(sprite) {
        let viewDistOffset = 0;
        if (sprite.viewDistOffset) {
            viewDistOffset = sprite.viewDistOffset;
        }
        if (player && player.valid) {
            let dist = Math.distanceBetween(player, sprite) - viewDistOffset;
            let maxViewDist = getMaxViewDistance();
            if (dist < maxViewDist) {
                if (isMobile) {
                    sprite.alpha = 1;
                } else {
                    if (dist > maxViewDist - 100) {
                        sprite.alpha = Math.abs((dist - maxViewDist) / 100);
                    } else {
                        sprite.alpha = 1;
                    }
                }
                return true;
            } else {
                return false;
            }
        } else {
            sprite.alpha = 1;
            return true;
        }
    }

    let spritesheetCache = {};
    function loadSpritesheet(texture, width, height, padding) {
        if (!padding) {
            padding = 0;
        }
        if (!spritesheetCache[texture.baseTexture.resource.url]) {
            let spritesheet = [];
            for (let w = 0; w < Math.round(texture.baseTexture.width / width); w++) {
                let arr = [];
                for (let h = 0; h < Math.round(texture.baseTexture.height / height); h++) {
                    let rectangle = new PIXI.Rectangle((w * width)+padding, (h * height)+padding, width-(padding*2), height-(padding*2));
                    let ntex = new PIXI.Texture(PIXI.BaseTexture.from(texture.baseTexture.resource.url), rectangle);
                    arr.push(ntex);
                }
                spritesheet.push(arr);
            }
            spritesheetCache[texture.baseTexture.resource.url] = spritesheet;
            return spritesheet;
        } else {
            return spritesheetCache[texture.baseTexture.resource.url];
        }
    }

    function createEntity(serverId, type, subtype, x, y, z, team, netData) {
        let entity = new PIXI.Container();
        entity.serverId = serverId;
        entity.subtype = subtype;
        entity.team = team;
        entity.netData = netData;

        entity.states = [];
        entity.x = x;
        entity.y = y;
        entity.z = z;
        entity.lastX = x;
        entity.lastY = y;
        entity.dx = 0;
        entity.dy = 0;
        entity.type = type;
        entity.valid = true;
        entity.visible = false;

        entity.tick = function (delta) {
            if (ENABLE_DEBUG && entity === player) {
                debugText.text += 'Entities: ' + entities.length + '\n';
                debugText.text += 'Tracked Entities: ' + Object.keys(entityDictionary).length + '\n';
                debugText.text += 'Entity Updates: ' + updatedEntityCount + '\n';
                debugText.text += 'States: ' + entity.states.length + '\n';
                debugText.text += 'DX: ' + Math.round(entity.dx) + '\n';
                debugText.text += 'DY: ' + Math.round(entity.dy) + '\n';
                debugText.text += 'Rot: ' + (entity.rotation && entity.rotation.toFixed ? entity.rotation.toFixed(2) : 0) + '\n';
            }

            if (entity.states.length >= 2) {
                let pos1 = entity.states[0];
                let pos2 = entity.states[1];
                //let currentTime = Date.now() - pos1.serverTimeDiff;
                //let val = (1 - (pos2.time - pos1.time) / (currentTime - pos1.time)) * 2;
                //let val = ((currentTime-pos1.time)/(pos2.time-pos1.time))-1;
                let val = pos1.val;
                val += (delta/snapshotRate)*0.6;
                pos1.val = val;

                if (val >= 0) {
                    let intpos = Math.lerp(pos1, pos2, val);
                    entity.x = intpos.x;
                    entity.y = intpos.y;

                    if (ENABLE_DEBUG && entity === player) {
                        debugText.text += 'diff: ' + pos1.serverTimeDiff + '\n';
                        debugText.text += 'val: ' + val + '\n';
                    }

                    if (Math.abs(pos1.rotation - pos2.rotation) > Math.PI*2.5) {
                        pos1.rotation = pos2.rotation;
                        entity.rotation = pos1.rotation;
                    } else {
                        if (Math.abs(pos1.rotation - pos2.rotation) > Math.PI) {
                            if (pos1.rotation > pos2.rotation) {
                                pos2.rotation += Math.PI * 2;
                            } else {
                                pos1.rotation += Math.PI * 2;
                            }
                        }

                        entity.rotation = Math.vallerp(pos1.rotation, pos2.rotation, val);
                    }

                    if (val >= 1) {
                        entity.states.shift();
                        if (entity.states[0]) {
                            let dist = Math.distanceBetween(entity, entity.states[0]);
                            if (dist < 250) {
                                entity.states[0].x = entity.x;
                                entity.states[0].y = entity.y;
                                entity.states[0].rotation = entity.rotation;
                            }
                        }
                    }
                    entity.z = pos2.z;
                }
            } else {
                if (ENABLE_DEBUG && entity === player) {
                    debugText.text += 'PACKET LOSS\n';
                }

                if (entity.states.length) {
                    entity.x = entity.states[0].x;
                    entity.y = entity.states[0].y;
                    entity.rotation = entity.states[0].rotation;
                }
            }

            if (entity.sprite) {
                entity.visible = entity.isVisible();
            }

            if (entity.z <= -1) {
                if (entity.scale.x !== 1.75) {
                    entity.scale.set(1.75);
                }
            } else {
                if (entity.scale.x !== 1) {
                    entity.scale.set(1);
                }
            }

            entity.dx = entity.x - entity.lastX;
            entity.dy = entity.y - entity.lastY;
            if (Math.abs(entity.dx) > 10 || Math.abs(entity.dy) > 10) {
                entity.dx = 0;
                entity.dy = 0;
            }

            entity.lastX = entity.x;
            entity.lastY = entity.y;
        };

        entity.changeName = function (newName) {
            entity.netData.name = newName.name;
            entity.netData.isDev = newName.isDev;
            entity.netData.settings = newName.settings;
        };

        entity.setHungry = function (hungry) {
            entity.netData.hungry = hungry;
        };

        entity.setFlying = function(flying) {
            entity.netData.flying = flying;
        };

        entity.addState = function (state) {
            state.val = 0;
            state.clientTime = Date.now();
            state.serverTimeDiff = Date.now() - state.time;
            let latestStateTime = 0;
            if (entity.states.length >= 2) {
                latestStateTime = entity.states[entity.states.length-1].time;
            }

            if (state.time > latestStateTime) {
                if (entity.states.length <= 1) {
                    let max = latency*2;
                    if (max < 400) {
                        max = 400;
                    }
                    let stateDiff = max;
                    if (entity.states[0]) {
                        stateDiff = state.clientTime - entity.states[0].clientTime;
                    }
                    if (stateDiff > max) {
                        entity.states = [{
                            time: state.time - Math.round((1000/6)*1.5),
                            serverTimeDiff: serverTimeDiff,
                            x: entity.x,
                            y: entity.y,
                            z: entity.z,
                            rotation: entity.rotation
                        }];
                    }
                }

                entity.states.push(state);
            }

            if (entity.states.length > 2) {
                entity.states.shift();
                let dist = Math.distanceBetween(entity, entity.states[0]);
                if (dist < 250) {
                    entity.states[0].x = entity.x;
                    entity.states[0].y = entity.y;
                    entity.states[0].rotation = entity.rotation;
                }
            }
        };

        entity.qualityChanged = function() {};

        entity.getZIndex = function () {
            return -entity.y;
        };

        /*
        entity.changeZLevel = function (data) {
            //entity.x = data[0];
            //entity.y = data[1];
            entity.z = data[2];
            //entity.rotation = data[3];
        };
        */

        entity.isVisible = function () {
            return (entity.z === camera.z || subtype === 'anthill' || (camera.z <= -1 && entity.z <= 0)) && isOnScreen(entity.x, entity.y) && isCloseToPlayer(entity);
        };

        entity.onRemove = function () {};

        entity.remove = function () {
            entity.valid = false;
            entity.onRemove();
            app.cstage.removeChild(entity);
        };

        app.cstage.addChild(entity);
        entities.push(entity);

        return entity;
    }

    function createEffect(type, x, y, z, width, height, data) {
        let effect = new PIXI.Container();
        if (!data) {
            data = {};
        }

        effect.x = x;
        effect.y = y;
        effect.z = z;
        effect.valid = true;
        effect.lastX = x;
        effect.lastY = y;
        effect.dx = 0;
        effect.dy = 0;
        effect.type = type;
        effect.maxLifetime = 100;

        let spritesheet = null;
        if (type === 'pheromone') {
            effect.maxLifetime = 4000;
            effect.sprite = new PIXI.Sprite(resources['pheromone'].texture);
            effect.sprite.width = width;
            effect.sprite.height = height;
            effect.sprite.anchor.set(0.5);
            effect.addChild(effect.sprite);

            if (data.color) {
                effect.sprite.tint = data.color;
            }
        } else if (type === 'acid') {
            effect.maxLifetime = 1000;
            effect.sprite = new PIXI.Sprite(resources['acid'].texture);
            effect.sprite.width = width;
            effect.sprite.height = height;
            effect.sprite.anchor.set(0.5);
            effect.addChild(effect.sprite);
            effect.rotation = Math.random()*Math.PI*2;

            let angle = Math.angleBetween(effect, {x: data.targetX, y: data.targetY});
            effect.dx = Math.cos(angle)*25;
            effect.dy = Math.sin(angle)*25;
        } else if (type === 'raindrop') {
            spritesheet = loadSpritesheet(resources['raindrop'].texture, 64, 64);
            effect.maxLifetime = 4000;
            effect.sprite = new PIXI.Sprite(spritesheet[0][0]);
            effect.sprite.width = width;
            effect.sprite.height = height;
            effect.sprite.anchor.set(0.5);
            effect.addChild(effect.sprite);
        } else if (type === 'snowflake') {
            effect.maxLifetime = 1000;
            effect.sprite = new PIXI.Sprite(resources['snowflake'].texture);
            effect.sprite.width = width;
            effect.sprite.height = height;
            effect.sprite.anchor.set(0.5);
            effect.addChild(effect.sprite);
            effect.rotation = Math.random()*Math.PI*2;

            effect.dx = Math.cos(Math.random()*Math.PI)*0.5;
            effect.dy = Math.cos(Math.random()*Math.PI)*0.5;
        } else if (type === 'leaf') {
            spritesheet = loadSpritesheet(resources['leaf_particles'].texture, 128, 128);
            let sx = Math.floor(Math.random() * 2);
            let sy = Math.floor(Math.random() * 2);
            effect.maxLifetime = 1000;
            effect.sprite = new PIXI.Sprite(spritesheet[sx][sy]);
            effect.sprite.width = width;
            effect.sprite.height = height;
            effect.sprite.anchor.set(0.5);
            effect.addChild(effect.sprite);
            effect.rotation = Math.random()*Math.PI*2;

            let shadow = new PIXI.Sprite(effect.sprite.texture);
            shadow.visible = false;
            shadow.tint = 0x000000;
            shadow.width = width;
            shadow.height = height;
            shadow.alpha = 0.4;
            shadow.anchor.set(0.5);
            shadow.getZIndex = function () {
                if (effect.onGround) {
                    return -effect.y + 500;
                }
                let val = (effect.lifetime/effect.maxLifetime);
                return -effect.y - (5500 * val);
            };
            effect.shadow = shadow;
            app.cstage.addChild(shadow);

            effect.dx = Math.cos(Math.random()*Math.PI)*0.5;
            effect.dy = Math.cos(Math.random()*Math.PI)*0.5;
            effect.drot = Math.cos(Math.random()*Math.PI)*0.01;
        }

        let frame = 0;
        let animation = 0;
        effect.lifetime = effect.maxLifetime;
        effect.tick = function () {
            if (effect.lifetime > 0) {
                effect.lifetime -= gameSpeed;
            } else {
                effect.remove();
            }

            if (type === 'acid') {
                effect.x += effect.dx;
                effect.y += effect.dy;
                let dist = Math.distanceBetween(effect, {x: data.targetX, y: data.targetY});
                if (dist <= 40) {
                    effect.remove();
                }
            } else if (type === 'raindrop') {
                frame += 0.6;
                if (Math.floor(frame) >= 4) {
                    frame = 0;
                    animation++;
                    if (animation >= 3) {
                        effect.remove();
                    }
                }

                if (effect.valid) {
                    effect.sprite.texture = spritesheet[Math.floor(frame)][animation];
                }
            } else if (type === 'snowflake') {
                let val = (effect.lifetime/effect.maxLifetime);
                if (val <= 0.5) {
                    effect.onGround = true;
                    effect.sprite.alpha = val/0.5;
                } else {
                    if (val > 0.8) {
                        effect.sprite.alpha = 1-((val-0.8)/0.2);
                    } else {
                        effect.sprite.alpha = 1;
                    }

                    effect.width = width * val;
                    effect.height = height * val;
                    effect.x += effect.dx*val;
                    effect.y += effect.dy*val;
                }

                if (currentSeason.type !== 'winter') {
                    effect.remove();
                }
            } else if (type === 'leaf') {
                let val = (effect.lifetime/effect.maxLifetime);
                if (val <= 0.6) {
                    effect.onGround = true;
                    effect.shadow.visible = false;
                    effect.sprite.alpha = val/0.6;
                    effect.shadow.alpha = ((1-((val-0.6)/0.2))*0.4) * effect.sprite.alpha;
                } else {
                    if (val > 0.8) {
                        effect.sprite.alpha = 1-((val-0.8)/0.2);
                    } else {
                        effect.sprite.alpha = 1;
                        effect.shadow.visible = effect.visible;
                        let sizeVal = (val-0.6)/0.2;
                        let offset = 40 * sizeVal;
                        effect.shadow.x = effect.x + offset;
                        effect.shadow.y = effect.y + offset;
                        effect.shadow.rotation = effect.rotation;
                        effect.shadow.scale.set((effect.scale.x + (0.3*sizeVal))-0.15);
                        if (val > 0.6) {
                            effect.shadow.alpha = ((1-((val-0.6)/0.2))*0.4) * effect.alpha;
                        }
                    }

                    effect.width = width * val;
                    effect.height = height * val;
                    effect.x += effect.dx * val;
                    effect.y += effect.dy * val;
                    effect.rotation += effect.drot;
                }
            } else if (type === 'pheromone') {
                effect.sprite.alpha = 0.75 * (effect.lifetime/effect.maxLifetime);
            }

            if (effect.sprite) {
                effect.visible = effect.isVisible();
            }

            effect.lastX = effect.x;
            effect.lastY = effect.y;
        };

        effect.getZIndex = function () {
            if (type === 'raindrop') {
                return -effect.y - 5500;
            } else if (type === 'snowflake' || type === 'leaf') {
                if (effect.onGround) {
                    return -effect.y + 500;
                }
                let val = (effect.lifetime/effect.maxLifetime);
                return -effect.y - (5500 * val);
            }
            return -effect.y + 50;
        };

        effect.isVisible = function () {
            return (effect.z === camera.z || (camera.z <= -1 && effect.z <= 0)) && isOnScreen(effect.x, effect.y);
        };

        effect.onRemove = function () {
            if (effect.shadow) {
                app.cstage.removeChild(effect.shadow);
            }
        };

        effect.remove = function () {
            effect.valid = false;
            effect.onRemove();
            app.cstage.removeChild(effect);
        };

        app.cstage.addChild(effect);
        effects.push(effect);
        return effect;
    }

    let screenOffset = 400;
    function isOnScreen(x, y) {
        let zoomRatio = WIDTH/(WIDTH*camera.zoom);
        let camX = camera.x * zoomRatio;
        let camY = camera.y * zoomRatio;
        let camWidth = WIDTH * zoomRatio;
        let camHeight = HEIGHT * zoomRatio;
        return x >= camX - screenOffset && y >= camY - screenOffset && x <= camX + camWidth + screenOffset && y <= camY + camHeight + screenOffset;
    }

    function getServerTime() {
        return Date.now() - serverTimeDiff;
    }

    game.onPlayerDead = function() {
        if (hasSandboxAccess) {
            spectating = true;
            player = null;
            game.isSandbox = true;
        } else {
            if (!game.roundEnded && game.services.ad.showBannerAd) {
                game.services.ad.showBannerAd();
            }
        }
    };

    game.onPlayerAlive = function() {
        if (game.services.ad.hideBannerAd) {
            game.services.ad.hideBannerAd();
        }
    };

    window.onbeforeunload = function() {
        if (game.isPlayScreen && socket && socket.connected) {
            return 'Are you sure you want to leave the game?';
        }
    };

    function getEdgePosition() {
        var rand = Math.random();
        if (rand <= 0.25) {
            return {
                x: (MAP_SIZE * TILE_SIZE) * Math.random(),
                y: 0
            };
        } else if (rand > 0.25 && rand <= 0.5) {
            return {
                x: 0,
                y: (MAP_SIZE * TILE_SIZE) * Math.random()
            };
        } else if (rand > 0.5 && rand <= 0.75) {
            return {
                x: (MAP_SIZE * TILE_SIZE) * Math.random(),
                y: (MAP_SIZE * TILE_SIZE)
            };
        }

        return {
            x: (MAP_SIZE * TILE_SIZE),
            y: (MAP_SIZE * TILE_SIZE) * Math.random()
        };
    }

    let undergroundPlaying = false;
    let ambientFadeAmount = 1;
    let ambientFadeRate = 0;
    let nextAmbient = null;
    let nextAmbientVol = 0;
    let currentAmbient = null;
    let currentAmbientVol = 0;
    function setNextAmbientSound(next, vol, fade) {
        if (currentAmbient !== next && nextAmbient !== next) {
            if (fade && currentAmbient) {
                nextAmbient = next;
                nextAmbientVol = vol;
                ambientFadeRate = fade;
            } else {
                if (currentAmbient) {
                    sounds[currentAmbient].pause();
                }

                currentAmbient = next;
                currentAmbientVol = vol;
                sounds[currentAmbient].volume(currentAmbientVol);
                sounds[currentAmbient].play();
            }
        }
    }
    function updateAmbientSounds() {
        if (currentAmbient) {
            sounds[currentAmbient].volume(currentAmbientVol * ambientFadeAmount);
            if (ambientFadeRate) {
                if (nextAmbient) {
                    ambientFadeAmount -= ambientFadeRate * gameSpeed;
                } else {
                    ambientFadeAmount += ambientFadeRate * gameSpeed;
                    if (ambientFadeAmount >= 1) {
                        ambientFadeRate = 0;
                        ambientFadeAmount = 1;
                    }
                }
            }

            if (ambientFadeAmount <= 0) {
                if (currentAmbient) {
                    sounds[currentAmbient].pause();
                }

                currentAmbient = nextAmbient;
                currentAmbientVol = nextAmbientVol;
                nextAmbient = null;
                if (currentAmbient && !undergroundPlaying) {
                    sounds[currentAmbient].volume(0);
                    sounds[currentAmbient].play();
                }
            }
        }

        if (game.isPlayScreen && sounds['aboveground']) {
            if (camera.z >= 1) {
                if (!undergroundPlaying) {
                    undergroundPlaying = true;
                    sounds['underground'].play();

                    if (currentAmbient) {
                        sounds[currentAmbient].pause();
                    }
                }

            } else {
                if (undergroundPlaying) {
                    undergroundPlaying = false;
                    sounds['underground'].pause();

                    if (currentAmbient) {
                        sounds[currentAmbient].play();
                    }
                }

                if (currentWeather && currentWeather.type === 'rain') {
                    setNextAmbientSound('rain', 0.02, 0.002);
                } else {
                    let season = currentSeason;
                    if (nextSeason && seasonVal >= 0.5) {
                        season = nextSeason;
                    }

                    if (nightVal <= 0.5) {
                        if (season.type === 'summer') {
                            setNextAmbientSound('aboveground_summer', 0.15, 0.002);
                        } else if (season.type === 'fall') {
                            setNextAmbientSound('aboveground_fall', 0.3, 0.002);
                        } else if (season.type === 'winter') {
                            setNextAmbientSound('aboveground_winter', 0.05, 0.002);
                        } else {
                            setNextAmbientSound('aboveground', 0.1, 0.002);
                        }
                    } else {
                        if (season.type === 'summer') {
                            setNextAmbientSound('aboveground_summer_night', 0.1, 0.002);
                        } else if (season.type === 'fall') {
                            setNextAmbientSound('aboveground_fall_night', 0.1, 0.002);
                        } else if (season.type === 'winter') {
                            setNextAmbientSound('aboveground_winter', 0.05, 0.002);
                        } else {
                            setNextAmbientSound('aboveground_night', 0.004, 0.002);
                        }
                    }
                }
            }
        }
    }

    let roundStartTimer = 0;
    let undergroundColorMatrix = new PIXI.filters.ColorMatrixFilter();
    let nightColorMatrix = new PIXI.filters.ColorMatrixFilter();
    let rainColorMatrix = new PIXI.filters.ColorMatrixFilter();
    let rainColorMatrix2 = new PIXI.filters.ColorMatrixFilter();
    let lightningColorMatrix = new PIXI.filters.ColorMatrixFilter();
    let vignetteFilter;

    let springColorMatrix = new PIXI.filters.ColorMatrixFilter();
    let summerColorMatrix = new PIXI.filters.ColorMatrixFilter();
    let summerColorMatrixHue = new PIXI.filters.ColorMatrixFilter();
    let fallColorMatrix = new PIXI.filters.ColorMatrixFilter();
    let winterColorMatrix = new PIXI.filters.ColorMatrixFilter();
    let winterColorMatrixHue = new PIXI.filters.ColorMatrixFilter();
    springColorMatrix.saturate(0.15, true);
    summerColorMatrix.saturate(0.3, true);
    summerColorMatrix.brightness(1.15, true);
    summerColorMatrixHue.hue(310, true);
    summerColorMatrixHue.defaultAlpha = 0.2;
    fallColorMatrix.saturate(0.1, true);
    fallColorMatrix.hue(350, true);
    winterColorMatrix.defaultAlpha = 0.5;
    winterColorMatrix.saturate(-0.2, true);
    winterColorMatrix.brightness(0.8, true);
    winterColorMatrixHue.hue(175, true);
    winterColorMatrixHue.defaultAlpha = 0.2;

    let dyingPlantColorMatrix = new PIXI.filters.ColorMatrixFilter();
    let dyingPlantColorMatrixHue = new PIXI.filters.ColorMatrixFilter();
    let deadPlantColorMatrix = new PIXI.filters.ColorMatrixFilter();
    let deadPlantColorMatrixHue = new PIXI.filters.ColorMatrixFilter();
    dyingPlantColorMatrixHue.hue(326, true);
    dyingPlantColorMatrixHue.defaultAlpha = 0.75;
    dyingPlantColorMatrix.saturate(-0.2, true);
    dyingPlantColorMatrix.padding = 50;
    deadPlantColorMatrixHue.hue(320, true);
    deadPlantColorMatrixHue.defaultAlpha = 0.75;
    deadPlantColorMatrix.saturate(-0.3, true);
    deadPlantColorMatrix.padding = 50;

    let seasonData = {
        spring: {
            background: 'bg0',
            filters: [springColorMatrix]
        },
        summer: {
            background: 'bg1',
            filters: [summerColorMatrix, summerColorMatrixHue]
        },
        fall: {
            background: 'bg2',
            filters: [fallColorMatrix],
            plantFilters: [dyingPlantColorMatrix, dyingPlantColorMatrixHue]
        },
        winter: {
            background: 'bg3',
            filters: [winterColorMatrix, winterColorMatrixHue],
            plantFilters: [deadPlantColorMatrix, deadPlantColorMatrixHue]
        }
    };

    let menuInit = false;
    let lastcx = -10;
    let lastcy = -10;
    let lastcz = -10;
    undergroundColorMatrix.night(0.1, true);
    nightColorMatrix.night(0.25, true);
    rainColorMatrix.greyscale(0.5, true);
    rainColorMatrix2.night(0.25, true);
    lightningColorMatrix.brightness(1.8, true);

    let snowTime = 0;
    let leafTime = 0;

    const FPSMIN = 25;
    let fpsCheck = null;
    let continuousMovement = false;
    let continuousMouseMovement = false;

    let lastTick = Date.now();
    let g_TICK = 10;
    let g_Time = 0;
    app.ticker.add(function () {
        let globalFilters = [];

        var timeNow = Date.now();
        var timeDiff = timeNow - g_Time;
        if (timeDiff < g_TICK) {
            return;
        }
        g_Time = timeNow;

        let delta = Date.now() - lastTick;
        lastTick = Date.now();

        if (!vignetteFilter) {
            vignetteFilter = new VignetteFilter({
                offset: new Float32Array(2),
                dimensions: new Float32Array(2),
                vignetting: 0.5,
                vignettingAlpha: 0.7,
                vignettingBlur: 0.3
            });
            vignetteFilter.uniforms.vignetting = 0.5;
            vignetteFilter.uniforms.vignettingAlpha = 0.7;
            vignetteFilter.uniforms.vignettingBlur = 0.3;
        }

        if (screenCoverSprite) {
            if (yearEndData) {
                if (screenCoverSprite.alpha < 1) {
                    screenCoverSprite.alpha += 0.005;
                } else {
                    screenCoverSprite.alpha = 1;
                    screenCoverSprite.textObj.alpha = 1;
                    screenCoverSprite.textObj.visible = true;
                    screenCoverSprite.textObj.text = 'Your Colony Hibernated\n\n';
                    if (yearEndData.antCount) {
                        screenCoverSprite.textObj.text += 'Ants: ' + yearEndData.antCount + '\n';
                        screenCoverSprite.textObj.text += 'Ants Frozen Outside: ' + yearEndData.antsFrozen + '\n';
                        screenCoverSprite.textObj.text += 'Stored Food: ' + yearEndData.foodCount + '\n';
                        screenCoverSprite.textObj.text += 'Food Eaten: ' + yearEndData.usedFood + '\n';
                        screenCoverSprite.textObj.text += 'Starved Ants: ' + yearEndData.starvationCount + '\n';
                    }
                }
            } else if (screenCoverSprite.visible) {
                screenCoverSprite.alpha -= 0.005;
                screenCoverSprite.textObj.visible = false;
                if (screenCoverSprite.alpha <= 0) {
                    screenCoverSprite.visible = false;
                    screenCoverSprite.textObj.visible = screenCoverSprite.visible;
                }
            } else {
                screenCoverSprite.textObj.visible = false;
            }
        }

        if (xpFeedText) {
            if (xpFeedText.displayTime) {
                xpFeedText.displayTime--;
                if (xpFeedText.displayTime <= 0) {
                    xpFeedText.displayTime = 0;
                }
            } else {
                if (xpFeedText.alpha > 0) {
                    xpFeedText.alpha -= 0.01;
                    if (xpFeedText.alpha <= 0) {
                        xpFeedText.alpha = 0;
                        xpFeedList = [];
                    }
                }
            }
        }

        if (game.settings.quality === 'auto') {
            let fps = Math.round(1000/delta);
            if (fps < FPSMIN) {
                if (!fpsCheck) {
                    fpsCheck = Date.now();
                } else if (Date.now()-fpsCheck >= 1500) {
                    game.settings.quality = 'low';
                    game.updateQuality();
                    game.showGrowl('Graphics quality was set to Low Quality due to low FPS.', {type: 'danger'});
                }
            } else {
                fpsCheck = null;
            }
        }

        game.resetZoom();

        let wmp = game.getMousePosition();
        gmx = wmp.x;
        gmy = wmp.y;

        if (currentPlayerData && !player) {
            if (currentPlayerData.id) {
                for (let i = 0; i < entities.length; i++) {
                    let entity = entities[i];
                    if (currentPlayerData.id === entity.serverId) {
                        player = entity;
                        player.canControl = currentPlayerData.canControl;
                        break;
                    }
                }

                if (player) {
                    if (currentMenu && currentMenu === 'lobby') {
                        currentMenu = null;
                    }
                }
            }

            if (currentPlayerData.spectator) {
                spectating = true;
                player = null;
            } else {
                spectating = false;
            }

            if (player && player.canControl) {
                game.onPlayerAlive();
                generateRadialMenu();
                currentPlayerData = null;
            }
        }

        if (currentMenu === 'lobby') {
            if (roundStartTimer) {
                roundStartTimer -= app.ticker.elapsedMS;
                let secondsTilStart = Math.round(roundStartTimer / 1000);
                if (game.lobbyComponent) {
                    game.lobbyComponent.updateRoundTimer(secondsTilStart);
                }
            } else {
                game.lobbyComponent.updateRoundTimer(null);
            }
        }

        let weather = getWeather();
        if (weather && weather.type === 'rain') {
            if (camera.z <= 0 && (weatherVal >= 1 || Math.random()*10 <= weatherVal)) {
                let zoomRatio = WIDTH / (WIDTH * camera.zoom);
                let camX = camera.x * zoomRatio;
                let camY = camera.y * zoomRatio;
                let camWidth = WIDTH * zoomRatio;
                let camHeight = HEIGHT * zoomRatio;

                let rx = camX + (camWidth * Math.random());
                let ry = camY + (camHeight * Math.random());
                let size = 64 - Math.round(20 * Math.random());
                createEffect('raindrop', rx, ry, 0, size, size);
            }
        } else if (weather && weather.type === 'snow' && currentSeason.type === 'winter') {
            snowTime -= gameSpeed;
            if (snowTime <= 0) {
                snowTime = 10 + ((1-weatherVal)*200);

                let zoomRatio = WIDTH / (WIDTH * camera.zoom);
                let camX = camera.x * zoomRatio;
                let camY = camera.y * zoomRatio;
                let camWidth = WIDTH * zoomRatio;
                let camHeight = HEIGHT * zoomRatio;

                let buffer = 300;
                let rx = (camX-buffer) + ((camWidth + (buffer*2)) * Math.random());
                let ry = (camY-buffer) + ((camHeight + (buffer*2)) * Math.random());
                let size = 42 + Math.round(20 * Math.random());
                createEffect('snowflake', rx, ry, 0, size, size);
            }
        }

        if ((currentSeason.type === 'fall' && !nextSeason) || (nextSeason && nextSeason.type === 'fall')) {
            leafTime -= gameSpeed;
            if (leafTime <= 0) {
                leafTime = 50 + ((1-seasonVal)*200);
                let zoomRatio = WIDTH / (WIDTH * camera.zoom);
                let camX = camera.x * zoomRatio;
                let camY = camera.y * zoomRatio;
                let camWidth = WIDTH * zoomRatio;
                let camHeight = HEIGHT * zoomRatio;

                let rx = camX + (camWidth * Math.random());
                let ry = camY + (camHeight * Math.random());
                let size = 100 + Math.round(20 * Math.random());
                createEffect('leaf', rx, ry, 0, size, size);
            }
        }

        if (tutorialContainer && tutorialContainer.tutorialData) {
            var wordPadding = 12;
            tutorialContainer.square.x = tutorialContainer.avatar.width;
            tutorialContainer.square.width = WIDTH;
            tutorialContainer.text.x = tutorialContainer.square.x + wordPadding;
            tutorialContainer.text.y = wordPadding;
            tutorialContainer.text.style.wordWrapWidth = (tutorialContainer.square.width - tutorialContainer.square.x) - (wordPadding*2);
            tutorialContainer.square.height = tutorialContainer.avatar.height;
            tutorialContainer.y = HEIGHT-tutorialContainer.height;
            tutorialContainer.visible = true;
        } else if (tutorialContainer) {
            tutorialContainer.visible = false;
        }

        if (!game.isPlayScreen) {
            if (!menuInit) {
                MAP_SIZE = Math.round(WIDTH/TILE_SIZE)+5;
                menuInit = true;
                for (var i=0; i<50; i++) {
                    createInsect(-1, 'ant_worker', Math.random() * WIDTH, Math.random() * HEIGHT, 0, 65, 65, Math.floor(Math.random()*8), {alive: true});
                }
            }

            for (var i=0; i<entities.length; i++) {
                var entity = entities[i];
                if (entity.subtype === 'ant_worker') {
                    if (!entity.moveTo) {
                        entity.moveTo = getEdgePosition();
                        entity.moveTo.x -= 200;
                        entity.moveTo.y -= 200;
                    }

                    if (entity.moveTo) {
                        var angle = Math.angleBetween(entity, entity.moveTo);
                        var dist = Math.distanceBetween(entity, entity.moveTo);

                        if (dist <= 20) {
                            entity.moveTo = null;
                        } else {
                            entity.rotation = angle + Math.PI / 2;
                            entity.x += Math.cos(angle) * 2;
                            entity.y += Math.sin(angle) * 2;
                        }
                    }
                }
            }
        }

        if (((player && player.valid && player.canControl) || game.isSandbox)) {
            let gmp = game.getMousePosition();
            var closestDist = 10000;
            var closestEntity = null;
            for (var i = 0; i < entities.length; i++) {
                var entity = entities[i];
                var check = false;
                var dist = Math.distanceBetween(gmp, entity);
                if (isSwitchingPlayer || isSelectingFollow) {
                    if (game.isSandbox) {
                        check = entity.type === 'insect' && !entity.netData.name && entity.netData.alive && dist <= 35
                    } else {
                        check = (entity.subtype === 'ant_worker' || (isSwitchingPlayer && entity.subtype === 'ant_queen')) && !entity.netData.name && entity.netData.alive && entity.team === player.team && dist <= 35;
                    }
                } else {
                    if (!game.isSandbox) {
                        check = (entity.subtype === 'brood' || entity.subtype === 'food' || entity.subtype === 'anthill' || entity.subtype === 'aphid') && dist <= (entity.subtype === 'anthill' ? 40 : 16);
                    }
                }

                if (entity.valid && (game.isSandbox || (entity.z === player.z && entity !== player)) && check && dist < closestDist) {
                    closestEntity = entity;
                    closestDist = dist;
                }

                if (entity.updateFilters) {
                    entity.updateFilters();
                } else {
                    entity.filters = null;
                }
            }

            if (closestEntity && closestEntity.valid) {
                closestEntity.filters = [glowHighlightFilter];
            }
        }

        if (showRadialMenu && ((player && player.valid && player.netData && player.netData.alive) || radialMenuData)) {
            let gmp = game.getMousePosition();
            for (var i = 0; i < radialItems.length; i++) {
                var menuItem = radialItems[i];
                var itemPos = {
                    x: radialMenuContainer.x + menuItem.x,
                    y: radialMenuContainer.y + menuItem.y
                };

                if (Math.distanceBetween(gmp, itemPos) <= 75) {
                    menuItem.text.style.fontSize = 25;
                    menuItem.text.style.fill = 0xFFFF99;
                    menuItem.text.filters = [glowHighlightFilter];
                } else {
                    menuItem.text.style.fontSize = 22;
                    menuItem.text.style.fill = 0xFFFFFF;
                    menuItem.text.filters = null;
                }
            }
        }

        if (camera.z >= 1 && tiles) {
            let zoomRatio = WIDTH / (WIDTH * camera.zoom);
            let camX = camera.x * zoomRatio;
            let camY = camera.y * zoomRatio;
            let camWidth = WIDTH * zoomRatio;
            let camHeight = HEIGHT * zoomRatio;

            let cx = Math.floor(camX/TILE_SIZE);
            let cy = Math.floor(camY/TILE_SIZE);
            if (player && player.valid) {
                cx = Math.floor((player.x - camWidth/2)/TILE_SIZE);
                cy = Math.floor((player.y - camHeight/2)/TILE_SIZE);
            }
            if (cx !== lastcx || cy !== lastcy || camera.z !== lastcz) {
                lastcx = cx;
                lastcy = cy;
                lastcz = camera.z;

                for (let y = 0; y < MAP_SIZE; y++) {
                    for (let x = 0; x < MAP_SIZE; x++) {
                        tiles[y][x].visible = false;
                    }
                }

                let tilePadding = 2;
                for (let tx = -tilePadding; tx < Math.floor(camWidth / TILE_SIZE) + tilePadding; tx++) {
                    for (let ty = -tilePadding; ty < Math.floor(camHeight / TILE_SIZE) + tilePadding; ty++) {
                        let ax = cx + tx;
                        let ay = cy + ty;
                        if (tiles[ay]) {
                            let tile = tiles[ay][ax];
                            if (tile) {
                                tile.visible = isCloseToPlayer(tile);
                            }
                        }
                    }
                }
            }
        }

        if (nightVal !== targetNightVal) {
            let diff = Math.abs(nightVal - targetNightVal);
            if (diff > 0.005) {
                if (nightVal > targetNightVal) {
                    nightVal -= 0.001 * gameSpeed;
                } else {
                    nightVal += 0.001 * gameSpeed;
                }
            } else {
                nightVal = targetNightVal;
            }
        }

        if (currentWeather) {
            if (weatherVal < 1) {
                weatherVal += (delta*0.0001) * gameSpeed;
            } else {
                weatherVal = 1;
            }
        } else {
            if (weatherVal > 0) {
                weatherVal -= (delta*0.0001) * gameSpeed;
            } else {
                weatherVal = 0;
            }
        }


        if (nextSeason) {
            if (seasonVal < 1) {
                seasonVal += (delta*0.00001) * gameSpeed;
            } else {
                seasonVal = 0;
                currentSeason = nextSeason;
                nextSeason = null;
            }
        }

        if (ENABLE_DEBUG) {
            debugText.text = 'Press F2 to disable debug\n';
            debugText.text += 'FPS: ' + Math.round(1000/delta) + '\n';
            debugText.text += 'Latency: ' + Math.round(latency) + 'ms\n';
        }

        for (let i=0; i<entities.length; i++) {
            let entity = entities[i];
            if (entity.valid) {
                entity.tick(delta);
            } else {
                entities.splice(i, 1);
                i--;
            }
        }

        for (let i=0; i<effects.length; i++) {
            let effect = effects[i];
            if (effect.valid) {
                effect.tick(timeDiff);
            } else {
                effects.splice(i, 1);
                i--;
            }
        }

        if (socket != null && socket.connected) {
            /*
            87 w
            65 a
            83 s
            68 d
             */

            let dx = 0;
            let dy = 0;
            if (!type_chat && player && (keys[87] || keys[83] || keys[65] || keys[68])) {
                if (keys[87]) {
                    dy = -1;
                } else if (keys[83]) {
                    dy = 1;
                }

                if (keys[65]) {
                    dx = -1;
                } else if (keys[68]) {
                    dx = 1;
                }

                if (dx !== 0 || dy !== 0) {
                    if (moveTimer <= 0) {
                        let movePos = {
                            x: player.x + dx*60,
                            y: player.y + dy*60,
                        };
                        socket.emit('move', {
                            angle: Math.angleBetween(player, movePos)
                        });
                        continuousMovement = true;
                        moveTimer = 2;
                    } else {
                        moveTimer--;
                    }
                }
            } else if (!type_chat && spectating && !isMobile) {
                if (keys[87]) {
                    dy = -1;
                } else if (keys[83]) {
                    dy = 1;
                }

                if (keys[65]) {
                    dx = -1;
                } else if (keys[68]) {
                    dx = 1;
                }

                if (dx !== 0) {
                    camera.x += dx * 15;
                }
                if (dy !== 0) {
                    camera.y += dy * 15;
                }
            } else if (!keys[87] && !keys[83] && !keys[65] && !keys[68]) {
                if (mouseDown) {
                    if (isMobile && spectating && !movingCamera && game.isSandbox && Date.now() - lastTapDown > 500 && !showRadialMenu) {
                        toggleRadialMenu();
                    } else if (currentMouseButton === 0 && player) {
                        let gmp = game.getMousePosition();
                        if (moveTimer <= 0) {
                            let dist = Math.distanceBetween(player, gmp);
                            if (dist > 60) {
                                socket.emit('move', {
                                    x: gmp.x,
                                    y: gmp.y,
                                    angle: Math.angleBetween(player, gmp)
                                });
                                continuousMovement = true;
                                continuousMouseMovement = true;
                                didAction = true;
                            }
                            moveTimer = 10;
                        } else {
                            moveTimer--;
                        }
                    }
                } else {
                    if (continuousMovement) {
                        if (continuousMouseMovement) {
                            let gmp = game.getMousePosition();
                            socket.emit('move', {
                                x: gmp.x,
                                y: gmp.y
                            });
                        } else {
                            socket.emit('move', {
                                stop: true
                            });
                        }
                        continuousMouseMovement = false;
                        continuousMovement = false;
                    }
                    moveTimer = 0;
                }
            }
        }

        if (camera.z <= 0) {
            background.scale.x = 2;
            background.scale.y = 2;
            backgroundFade.scale.x = 2;
            backgroundFade.scale.y = 2;
            backgroundFade.width = background.width;
            backgroundFade.height = background.height;
            let fromSeason = seasonData[currentSeason.type];
            if (fromSeason) {
                background.texture = resources[fromSeason.background].texture;

                if (game.settings.quality === 'auto' || game.settings.quality === 'high') {
                    globalFilters = globalFilters.concat(fromSeason.filters);

                    for (let i = 0; i < fromSeason.filters.length; i++) {
                        let filter = fromSeason.filters[i];
                        filter.alpha = (filter.defaultAlpha ? filter.defaultAlpha : 1);
                    }

                    if (fromSeason.plantFilters) {
                        for (let i = 0; i < fromSeason.plantFilters.length; i++) {
                            let filter = fromSeason.plantFilters[i];
                            filter.alpha = (filter.defaultAlpha ? filter.defaultAlpha : 1);
                        }
                    }
                }
            }

            if (nextSeason) {
                let toSeason = seasonData[nextSeason.type];
                if (toSeason) {
                    backgroundFade.texture = resources[toSeason.background].texture;
                    backgroundFade.alpha = seasonVal;
                    if (game.settings.quality === 'auto' || game.settings.quality === 'high') {
                        globalFilters = globalFilters.concat(toSeason.filters);

                        for (let i = 0; i < fromSeason.filters.length; i++) {
                            let filter = fromSeason.filters[i];
                            filter.alpha = (filter.defaultAlpha ? filter.defaultAlpha : 1) * (1 - seasonVal);
                        }
                        for (let i = 0; i < toSeason.filters.length; i++) {
                            let filter = toSeason.filters[i];
                            filter.alpha = (filter.defaultAlpha ? filter.defaultAlpha : 1) * seasonVal;
                        }

                        if (fromSeason.plantFilters) {
                            for (let i = 0; i < fromSeason.plantFilters.length; i++) {
                                let filter = fromSeason.plantFilters[i];
                                filter.alpha = (filter.defaultAlpha ? filter.defaultAlpha : 1) * (1 - seasonVal);
                            }
                        }
                        if (toSeason.plantFilters) {
                            for (let i = 0; i < toSeason.plantFilters.length; i++) {
                                let filter = toSeason.plantFilters[i];
                                filter.alpha = (filter.defaultAlpha ? filter.defaultAlpha : 1) * seasonVal;
                            }
                        }
                    }
                }
                backgroundFade.visible = !!toSeason;
            } else {
                backgroundFade.visible = false;
            }
        } else {
            background.scale.x = 1.5;
            background.scale.y = 1.5;
            background.texture = resources['underground_bg'].texture;
            backgroundFade.visible = false;
        }

        if (radialMenuContainer) {
            if (game.isSandbox) {
                radialMenuContainer.visible = showRadialMenu && radialMenuData;
                if (radialMenuContainer.visible) {
                    radialMenuContainer.x = radialMenuData.x;
                    radialMenuContainer.y = radialMenuData.y;
                }
            } else {
                radialMenuContainer.visible = player && player.netData.alive && showRadialMenu;
                if (radialMenuContainer.visible) {
                    radialMenuContainer.x = player.x;
                    radialMenuContainer.y = player.y - 5;
                }
            }
        }

        if (game.isSandbox && currentSandboxTool) {
            tipsText.text = currentSandboxTool.name;
            tipsText.visible = true;
        } else if (isSwitchingPlayer) {
            tipsText.text = 'Tap another ant to switch to.';
            tipsText.visible = true;
        } else if (isSelectingFollow) {
            tipsText.text = 'Tap another ant to follow you. (Right click or tap your ant to stop)';
            tipsText.visible = true;
        } else {
            tipsText.visible = false;
        }

        if (player && !spectating) {
            let target = {
                x: (player.x * camera.zoom) - WIDTH / 2,
                y: (player.y * camera.zoom) - HEIGHT / 2
            };

            if (game.roundEnded) {
                target.y += 120;
            }

            //camera.x = target.x;
            //camera.y = target.y;

            let dist = Math.distanceBetween(camera, target);
            if (dist <= 1 || dist >= 1000) {
                camera.x = target.x;
                camera.y = target.y;
            } else {
                let angle = Math.angleBetween(camera, target);
                let speed = (dist*0.25);
                if (speed < 2) {
                    speed = 2;
                }
                camera.x += Math.cos(angle) * speed;
                camera.y += Math.sin(angle) * speed;
            }

            camera.z = player.z;
        }

        if (arrowSpritePointer) {
            if (player && teamInfo && teamInfo.anthillPos) {
                let dist = Math.distanceBetween(player, teamInfo.anthillPos);
                if (dist > WIDTH / 3) {
                    let angle = Math.angleBetween(player, teamInfo.anthillPos);
                    arrowSpritePointer.visible = true;
                    arrowSpritePointer.x = player.x + Math.cos(angle) * (WIDTH / 6);
                    arrowSpritePointer.y = player.y + Math.sin(angle) * (HEIGHT / 6);
                    arrowSpritePointer.rotation = angle + Math.PI / 2;
                } else {
                    arrowSpritePointer.visible = false;
                }
            } else {
                arrowSpritePointer.visible = false;
            }
        }

        if (queenHungryContainer) {
            queenHungryContainer.visible = (teamInfo && teamInfo.queenHungry);
        }

        if (tileContainers) {
            for (var z=0; z<2; z++) {
                var tileContainer = tileContainers[z];
                if (tileContainer) {
                    tileContainer.visible = (camera.z === z || (z <= 0 && camera.z <= 0));
                }
            }
        }

        updateAmbientSounds();

        let zoomRatio = WIDTH / (WIDTH * camera.zoom);
        let camX = camera.x * zoomRatio;
        let camY = camera.y * zoomRatio;
        let camWidth = WIDTH * zoomRatio;
        let camHeight = HEIGHT * zoomRatio;

        if (camera.x < 0) {
            camera.x = 0;
        }

        if (camX + camWidth > MAP_SIZE * TILE_SIZE) {
            camera.x = ((MAP_SIZE * TILE_SIZE) - camWidth) * camera.zoom;
        }

        if (camera.y < 0) {
            camera.y = 0;
        }

        if (camY + camHeight > MAP_SIZE * TILE_SIZE) {
            camera.y = ((MAP_SIZE * TILE_SIZE) - camHeight) * camera.zoom;
        }

        let viewZoom = camera.zoom;
        if (viewZoom < 1) {
            viewZoom = 1;
        }
        let viewDist = getMaxViewDistance() * viewZoom;
        let largestWindowSize = WIDTH;
        if (HEIGHT > largestWindowSize) {
            largestWindowSize = HEIGHT;
        }

        let vignetteSize = 1 - (viewDist/largestWindowSize);
        if (vignetteSize > 0.9) {
            vignetteSize = 0.9;
        } else if (vignetteSize <= 0.01) {
            vignetteSize = 0.01;
        }

        camX = camera.x * zoomRatio;
        camY = camera.y * zoomRatio;
        camWidth = WIDTH * zoomRatio;
        camHeight = HEIGHT * zoomRatio;
        if (player && player.valid) {
            vignetteFilter.uniforms.offset[0] = player.x - (camX + (camWidth/2));
            vignetteFilter.uniforms.offset[1] = player.y - (camY + (camHeight/2));
        } else {
            vignetteFilter.uniforms.offset[0] = 0;
            vignetteFilter.uniforms.offset[1] = 0;
        }
        vignetteFilter.uniforms.dimensions[0] = WIDTH;
        vignetteFilter.uniforms.dimensions[1] = HEIGHT;

        if (camera.z >= 1) {
            undergroundColorMatrix.alpha = 0.35;
            if (isMobile) {
                app.cstage.filters = [undergroundColorMatrix];
            } else {
                vignetteFilter.uniforms.vignetting = vignetteSize;
                app.cstage.filters = [undergroundColorMatrix, vignetteFilter];
            }
        } else {
            let weather = getWeather();
            if (weather && weatherVal !== 0) {
                if (weather.type === 'rain') {
                    rainColorMatrix2.alpha = 0.1 * weatherVal;
                    rainColorMatrix.alpha = 0.4 * weatherVal;
                    globalFilters.push(rainColorMatrix2);
                    globalFilters.push(rainColorMatrix);

                    if (weather.lightning) {
                        if (Date.now() - weather.lightning.start <= weather.lightning.lightEnd) {
                            if (Date.now()%2 === 0) {
                                lightningColorMatrix.alpha = 0.5+Math.random();
                            }
                            globalFilters.push(lightningColorMatrix);
                        }
                    }
                }
            }

            if (nightVal !== 0) {
                nightColorMatrix.alpha = 0.35 * nightVal;
                globalFilters.push(nightColorMatrix);
            }

            if (!isMobile) {
                vignetteFilter.uniforms.vignetting = vignetteSize;
                globalFilters.push(vignetteFilter);
            }
            app.cstage.filters = globalFilters;
        }

        if (weather && weather.lightning && weather.lightning.end - Date.now() <= 0) {
            sounds['thunder' + weather.lightning.sound].play();
            delete weather.lightning;
        }

        if (game.isSandbox && socket) {
            if (moveTimer <= 0) {
                socket.emit('sandboxPosition', {
                    x: camX + camWidth/2,
                    y: camY + camHeight/2,
                    z: camera.z
                });
                moveTimer = 10;
            } else {
                moveTimer--;
            }
        }

        spawnText.visible = game.isPlayScreen && !game.isMapEditor && !spectating && !currentMenu && (!player || !player.canControl || !player.netData.alive) && !game.roundEnded;

        if (game.isPlayScreen) {
            app.cstage.x = Math.floor(-camera.x);
            app.cstage.y = Math.floor(-camera.y);
            app.cstage.scale.x = camera.zoom;
            app.cstage.scale.y = camera.zoom;
            app.cstage.updateLayersOrder();
        }
    });

    game.disconnect = function() {
        window.location.reload();
    };

    setInterval(function() {
        if (window.ga && socket && socket.connected) {
            ga('send', 'event', 'heartbeat', '60s');
        }
    }, 60000);

    /*
    setTimeout(function() {
        game.roundEndComponent.showRoundEnd({
            roundActuallyEnded: true,
            message: 'BLACK TEAM WINS',
            awards: {
                xp: 1400,
                coins: 10,
            },
            lastXp: 600,
            isUser: true
        });
    }, 500);
    */

    function copyToClipboard(elem) {
        // create hidden text element, if it doesn't already exist
        var targetId = "_hiddenCopyText_";
        var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
        var origSelectionStart, origSelectionEnd;
        if (isInput) {
            // can just use the original source element for the selection and copy
            target = elem;
            origSelectionStart = elem.selectionStart;
            origSelectionEnd = elem.selectionEnd;
        } else {
            // must use a temporary form element for the selection and copy
            target = document.getElementById(targetId);
            if (!target) {
                var target = document.createElement("textarea");
                target.style.position = "absolute";
                target.style.left = "-9999px";
                target.style.top = "0";
                target.id = targetId;
                document.body.appendChild(target);
            }
            target.textContent = elem.textContent;
        }
        // select the content
        var currentFocus = document.activeElement;
        target.focus();
        target.setSelectionRange(0, target.value.length);

        // copy the selection
        var succeed;
        try {
            succeed = document.execCommand("copy");
        } catch(e) {
            succeed = false;
        }
        // restore original focus
        if (currentFocus && typeof currentFocus.focus === "function") {
            currentFocus.focus();
        }

        if (isInput) {
            // restore prior selection
            elem.setSelectionRange(origSelectionStart, origSelectionEnd);
        } else {
            // clear temporary content
            target.textContent = "";
        }
        return succeed;
    }

    function toTitleCase(str) {
        return str.replace(/\w\S*/g, function(txt){
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }

    game.clearEntities = () => {
        for (let i=0; i<entities.length; i++) {
            let entity = entities[i];
            entity.remove();
        }
    };

    var lobbyChatText = $('#lobby-menu-chat-text');
    var lastMessageTime = 0;
    lobbyChatText.bind('enterKey', function(e) {
        e.preventDefault();
        var message = lobbyChatText.val();
        if (message && message.trim) {
            message = message.trim();
        }

        lobbyChatText.val('');
        if (socket && message && message.length >= 1 && message.length <= 500 && Date.now() - lastMessageTime > 600) {
            lastMessageTime = Date.now();
            game.chat(message);
        }
    });

    lobbyChatText.keyup(function(e) {
        e.preventDefault();
        if (e.keyCode === 13)  {
            $(this).trigger('enterKey');
        }
    });

    var showingScoreboard = false;
    function showScoreboard(hideIfAlreadyShowing) {
        if (!showingScoreboard && !currentMenu) {
            showingScoreboard = true;
            if (game.lobbyComponent) {
                game.lobbyComponent.showModal(true);
            }

            if (socket) {
                socket.emit('scoreboard', null);
            }
        } else if (hideIfAlreadyShowing && showingScoreboard) {
            hideScoreboard();
        }
    }
    game.showScoreboard = showScoreboard;

    function updateScoreboard() {
        if (game.lobbyComponent) {
            game.lobbyComponent.updateData(scoreboardData);
        }
    }

    function hideScoreboard() {
        if (showingScoreboard) {
            if (game.lobbyComponent) {
                game.lobbyComponent.showModal(false);
            }
            scoreboardData = null;
            showingScoreboard = false;
        }
    }

    function getClientById(clientId) {
        for (var i=0; i<scoreboardData.players.length; i++) {
            var player = scoreboardData.players[i];
            if (player.clientId === clientId) {
                return player;
            }
        }
    }

    game.openPlayerMenu = function(clientId) {
        $('#scoreboardModal').hide();
        game.openReportMenu(clientId);
    };

    var reportingPlayer = null;
    game.openReportMenu = function(clientId) {
        var player = getClientById(clientId);
        if (player) {
            inOverlayMenu = true;
            $('#reportMenuModal').show();
            $('#report-menu-name').text(player.name);
            reportingPlayer = player;
        }
    };

    game.submitReport = function() {
        if (reportingPlayer) {
            var data = objectifyForm($('#report-player-form'));
            var reason = data.reportMessage.trim();
            if (reason && reason.length > 6) {
                socket.emit('reportPlayer', {
                    clientId: reportingPlayer.clientId,
                    reason: reason
                });
                reportingPlayer = null;
                game.closeReportMenu();
            } else {
                game.showGrowl('Report reason must be longer than 6 characters.', {type: 'danger'});
            }
        }
    };

    game.closeReportMenu = function() {
        inOverlayMenu = false;
        $('#reportMessage').val('');
        $('#reportMenuModal').hide();
    };

    game.lobbyReady = function() {
        socket.emit('lobbyReady');
    };

    game.lobbyJoinTeam = function(team) {
        socket.emit('lobbyJoinTeam', team);
    };

    game.lobbyNewTeam = function() {
        socket.emit('lobbyNewTeam');
    };

    game.lobbyLockTeam = function() {
        socket.emit('lobbyLockTeam');
    };

    game.copyShareLink = function(elementId) {
        try {
            copyToClipboard(document.getElementById(elementId));
            game.showGrowl('Link copied to clipboard!', {type: 'success'});
        } catch (e) {
            game.showGrowl('Failed to copy! Try and select the link.', {type: 'danger'});
        }
    };

    Math.angleBetween = function (p1, p2) {
        return Math.atan2(p2.y - p1.y, p2.x - p1.x);
    };
    Math.distanceBetween = function (p1, p2) {
        return Math.sqrt(Math.pow((p1.x - p2.x), 2) + Math.pow((p1.y - p2.y), 2));
    };
    Math.magnitude = function (p1) {
        return Math.hypot(p1.dx, p1.dy);
    };
    Math.vallerp = function (val1, val2, value) {
        return val1 + (val2 - val1) * value;
    };
    Math.lerp = function (vec1, vec2, value) {
        return {
            x: vec1.x + (vec2.x - vec1.x) * value,
            y: vec1.y + (vec2.y - vec1.y) * value
        };
    };

    function VignetteFilter(uniforms) {
        var vertexShader = null;
        var fragmentShader = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 filterArea;
uniform vec2 offset;
uniform vec2 dimensions;

uniform float vignetting;
uniform float vignettingAlpha;
uniform float vignettingBlur;

const float SQRT_2 = 1.414213;

void main()
{
    gl_FragColor = texture2D(uSampler, vTextureCoord);
    vec3 color = gl_FragColor.rgb;

    vec2 pixelSize = vec2(1.0) / dimensions.xy;
    vec2 coord = (vTextureCoord * filterArea.xy / dimensions.xy) - (pixelSize * offset);
    if (vignetting > 0.0)
    {
        float outter = SQRT_2 - vignetting * SQRT_2;
        vec2 dir = vec2(vec2(0.5, 0.5) - coord);
        dir.y *= dimensions.y / dimensions.x;
        float darker = clamp((outter - length(dir) * SQRT_2) / ( 0.00001 + vignettingBlur * SQRT_2), 0.0, 1.0);
        color.rgb *= darker + (1.0 - darker) * (1.0 - vignettingAlpha);
    }

    gl_FragColor.rgb = color;
}
        `;

        PIXI.Filter.call(this,
            vertexShader,
            fragmentShader,
            uniforms
        );
        this.legacy = true;

        this.uniforms.offset = new Float32Array(2);
        this.uniforms.dimensions = new Float32Array(2);
    }
    VignetteFilter.prototype = Object.create(PIXI.Filter.prototype);
    VignetteFilter.prototype.constructor = VignetteFilter;
})();
